import React from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import {
  MDBContainer,
  MDBTable,
  MDBTableBody,
  MDBTableHead,
  MDBDataTable,
  MDBDataTableV5,
} from "mdbreact";
import * as misConstantes from "../../../../js/constantes.js";
import InicioBreadcrumbs from "../../../../pages/template/breadcrumbs/InicioBreadcrumbs.js";
import Select from "react-select";
import ReactHtmlParser, {
  processNodes,
  convertNodeToElement,
  htmlparser2,
} from "react-html-parser";

import {
  Switch,
  Route,
  BrowserRouter,
  Link,
  useLocation,
  useParams,
} from "react-router-dom";

import axios from "axios";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import OfertaTodosProveedores from "./OfertaTodosProveedores.js";
import ChatSimulacion from "../../../../components/chat/ChatSimulacion";

class Cotizacion extends React.Component {
  constructor(props) {
    super(props);

    var url = window.location.href;
    var data = url.split("/");
    var idCotizacion = data[data.length - 1];
    try {
      var usuarioActual = JSON.parse(localStorage.getItem("usuario"));
      this.idUsuarioActual = usuarioActual && usuarioActual.usuario ? usuarioActual.usuario.id : null;
    } catch (e) {
      this.idUsuarioActual = null;
    }
    var visualizacionOfertada = "";

    var columnas = [
      { field: "texto", label: "Texto", attributes: { width: "35%" } },
      //								{ field: "precioSimulacicraon", label: "Simulación", attributes: {'width':'15%'} },
      {
        field: "precioUnitarioAntesImpuestos",
        label: "Pre Uni",
        attributes: { width: "15%" },
      },
      { field: "cantidad", label: "Cant", attributes: { width: "10%" } },
      {
        field: "totalImpuestosPositivos",
        label: "IVA",
        attributes: { width: "10%" },
      },
      { field: "descuento", label: "Descuento", attributes: { width: "10%" } },
      { field: "subtotal", label: "Subtotal", attributes: { width: "10%" } },
      {
        field: "botones",
        label: "",
        sort: "asc",
        width: "10%",
        attributes: { width: "10%", align: "center" },
      },
    ];

    var columnasCerrado = [
      { field: "texto", label: "Texto", attributes: { width: "30%" } },
      {
        field: "precioSimulacion",
        label: "Simulación",
        attributes: { width: "15%" },
      },
      {
        field: "precioUnitarioAntesImpuestos",
        label: "Pre Uni",
        attributes: { width: "8%" },
      },
      { field: "cantidad", label: "Cant", attributes: { width: "7%" } },
      {
        field: "totalImpuestosPositivos",
        label: "IVA",
        attributes: { width: "15%" },
      },
      { field: "descuento", label: "Descuento", attributes: { width: "10%" } },
      { field: "subtotal", label: "Subtotal", attributes: { width: "10%" } },
    ];

    var columnasArchivos = [
      { field: "nombre", label: "Nombre", attributes: { width: "30%" } },
      {
        field: "descripcion",
        label: "Descripcion",
        attributes: { width: "50%" },
      },
      {
        field: "botones",
        label: "",
        sort: "asc",
        width: "20%",
        attributes: { width: "20%", align: "center" },
      },
    ];

    var columnasCategoriasProducto = [
      {
        field: "categoria",
        label: "Categoria descuento",
        attributes: { width: "50%" },
      },
      { field: "valor", label: "Valor", attributes: { width: "30%" } },
      {
        field: "botones",
        label: "",
        sort: "asc",
        width: "20%",
        attributes: { width: "20%", align: "center" },
      },
    ];

    var columnasArchivosCerrada = [
      { field: "nombre", label: "Nombre", attributes: { width: "30%" } },
      {
        field: "descripcion",
        label: "Descripcion",
        attributes: { width: "50%" },
      },
    ];

    var columnasArchivosSimulacion = [
      { field: "nombre", label: "Nombre", attributes: { width: "40%" } },
      {
        field: "descripcion",
        label: "Descripción",
        attributes: { width: "60%" },
      },
    ];

    var columnasGravamenesSimulacion = [
      { field: "nombre", label: "Gravamen", attributes: { width: "60%" } },
      { field: "valor", label: "Valor", attributes: { width: "40%" } },
    ];

    var columnasGravamenesSimulacion = [
      { field: "nombre", label: "Gravamen", attributes: { width: "60%" } },
      { field: "valor", label: "Valor", attributes: { width: "40%" } },
    ];

    var columnasResultadoProveedoresValidasMontoAgotable = [
      { field: "proveedor", label: "Proveedor", attributes: { width: "45%" } },
      {
        field: "valor",
        label: "Valor",
        width: "25%",
        attributes: { width: "25%", align: "center" },
      },
      {
        field: "cantidad",
        label: "Cantidad",
        width: "20%",
        attributes: { width: "25%", align: "center" },
      },
      {
        field: "botones",
        label: "",
        sort: "asc",
        width: "10%",
        attributes: { width: "10%", align: "center" },
      },
    ];

    var columnasCotizacionesOtrosProveedores = [
      { field: "consecutivo", label: "#", attributes: { width: "15%" } },
      { field: "proveedor", label: "Proveedor", attributes: { width: "50%" } },
      { field: "valor", label: "Valor", attributes: { width: "25%" } },
      {
        field: "botones",
        label: "",
        sort: "asc",
        width: "10%",
        attributes: { width: "10%", align: "center" },
      },
    ];

    this.state = {
      datos: { columns: columnas, rows: [] },
      columnasCerrado: columnasCerrado,
      mostrarEditarItemCotizacion: false,
      idEditarSimulador: -1,
      respuestaEditarItemCotizacion: "",
      ivaEditar: "",
      valorIVAEditar: "",
      precioUnitarioAntesImpuestos: "",
      descuentoPorcentajeEditar: "",
      precioUnitarioSimulacion: 0,
      requiereEdicionProveedor: false,
      columnas: columnas,
      idCotizacion: idCotizacion,
      entidad: { nombre: "" },
      simulador: { nombre: "" },
      mostrarIVATodosProductos: false,
      ivaTodosProductos: "",
      mostrarDescuentoTodosProductos: false,
      descuentoTodosProductos: "",
      marcasProveedor: [],
      esAdjudicacionMultiple: false,
      seleccionoMarca: false,
      cotizacion: {
        stotalIVA: "",
        stotalDescuento: "",
        stotal: "",
        ssubtotal: "",
      },
      cotizacion: {},

      mostrarCerrarCotizacion: false,
      descuentoPorcentaje: 0,
      mostrarDescuento: "initial",
      mostrarBotones: "initial",
      simulacion: null,
      idSimulacion: -1,
      eventoCotizacion: null,
      fechaRespuesta: "",
      diasCuentaRegresiva: "",
      horasCuentaRegresiva: "",
      minutosCuentaRegresiva: "",

      consecutivoCotizacion: "",
      nombreSimulador: "",
      nombreEntidad: "",
      consecutivoEventoCotizacion: "",
      consecutivoProcesoSimulacion: "",

      archivos: { columns: columnasArchivos, rows: [] },
      columnasArchivos: columnasArchivos,
      columnasArchivosCerrada: columnasArchivosCerrada,
      selectedFile: {},
      mostrarInsertarArchivoProveedorProcesoSimulacion: false,
      nombreInsertarArchivoProveedorProcesoSimulacion: "",
      descripcionInsertarArchivoProveedorProcesoSimulacion: "",
      respuestaInsertarArchivoProveedorProcesoSimulacion: "",
      mostrarEditarArchivoProveedorProcesoSimulacion: false,
      nombreEditarArchivoProveedorProcesoSimulacion: "",
      descripcionEditarArchivoProveedorProcesoSimulacion: "",
      idEditarSimulador: -1,
      respuestaEditarArchivoProveedorProcesoSimulacion: "",
      mostrarEliminarArchivoProveedorProcesoSimulacion: false,
      nombreEliminarArchivoProveedorProcesoSimulacion: "",
      idEliminarArchivoProveedorProcesoSimulacion: -1,
      respuestaEliminarArchivoProveedorProcesoSimulacion: "",

      necesidadBien: "",
      destinacionGasto: "",
      origenRecursos: "",
      supervisores: [],
      direcciones: [],
      datosExtras: [],
      datosArchivosSimulacion: {
        columns: columnasArchivosSimulacion,
        rows: [],
      },
      columnasArchivosSimulacion: columnasArchivosSimulacion,
      gravamenesSimulacion: { columns: columnasGravamenesSimulacion, rows: [] },
      columnasGravamenesSimulacion: columnasGravamenesSimulacion,
      colorContador: "#1564c1",
      mensajeContador: "initial",
      mensajeContadorVencido: "none",

      mostrarEnviarCotizacion: false,
      mensajeRespuestaEnviarCotizacion: "",
      mostrarBotones: "initial",
      archivoCotizacion: {},
      mostrarSubirPreciosMasivos: false,
      respuestaSubirArchivoCargueMasivoPrecios: "",
      cargandoItemsCotizacion: "",
      mostrarEditarItemCotizacionOfertado: false,
      mensajeModificarValoresOfertado: "",
      mostrarEditarItemCotizacionAbierto: false,
      idItemCotizacionEdicionAbierto: -1,
      idItemCotizacionEdicionOfertado: -1,
      mensajeModificarValoresAbierto: "",

      mostrarEditarItemCotizacionPiso: false,
      idItemCotizacionEdicionPiso: -1,

      mostrarDatosMontoAgotable: "none",
      presupuesto: "",
      cantidadOferta: "",
      mostrarDatosminimoPrecio: "none",
      mostrarActualizarModificarCantidad: false,
      mensajeActualizarCantidadOfertada: "",
      tipoCotizacion: 1,
      mostrarInsertarProducto: "none",
      productosProveedor: [],
      productosAbiertos: [],
      mostrarDialogoInsertarProducto: false,
      productoInsertar: {},
      itemOfertar: {},
      mensajeInsertarProducto: "",
      mostrarEliminarItemCotizacionProcesoSimulacion: "",
      idEliminarItemCotizacionSimulacion: -1,
      nombreItemEliminarCotizacion: "",
      respuestaEliminarItemProcesoSimulacion: "",
      ivaCantidad: "",
      valorAntesIVACantidad: "",
      descuentoCantidad: "",

      mostrarSolicitarMarca: false,
      mostrarCambiarMarca: false,
      respuestaMarca: "",
      idItemCotizacionMarca: -1,
      cotizacionValida: true,
      mostrarErrores: "none",
      mensajeErrores: "",

      datosCategoriasProducto: {
        columns: columnasCategoriasProducto,
        rows: [],
      },

      mostrarInsertarCategoriaProductoCotizacionValor: false,
      respuestaInsertarCategoriaProductoCotizacionValor: "",
      mostrarEditarCategoriaProductoCotizacionValor: false,
      respuestaEditarCategoriaProductoCotizacionValor: "",
      mostrarEliminarCategoriaProductoCotizacionValor: false,
      respuestaEliminarCategoriaProductoCotizacionValor: "",
      nombreEliminarCategoriaProductoCotizacionValor: "",
      idCategoriaProductoEliminar: -1,

      colorMensajeCargando: "#f5aa42",
      mensajeCargandoArchivo: "",
      mostrarMensajeCargando: "none",

      archivoCotizacionPrecio: {},
      mostrarSubirPreciosPrecioMasivos: false,
      respuestaSubirArchivoCargueMasivoPreciosPrecio: "",
      nombreCatalogo: "",
      mostrarErroresEventoCotizacion: "none",
      mensajesErroresEventoCotizacion: "",
      estadoEnvio: "",

      visualizacionBotonSimuladorProveedor: {},
      nombreContacto: "",
      correoContacto: "",
      telefonoContacto: "",
      mostrarDescuentoValorActualizarItem: "",
      mostrarValorCatalogoActualizarItem: "",
      valorCatalogo: 0,

      productos: [],
      mostrarCantidadInsertarProducto: "",
      IVAvalorCatalogo: 0,

      simulaciones: {
        columns: columnasResultadoProveedoresValidasMontoAgotable,
        rows: [],
      },
      columnasResultadoProveedoresValidasMontoAgotable:
        columnasResultadoProveedoresValidasMontoAgotable,

      nombreTipoSimulador: "",


      puedeVerCotizaciones: "none",
      columnasCotizacionesOtrosProveedores:
        columnasCotizacionesOtrosProveedores,
      dataCotizacionesOtrosProveedores: {
        columns: columnasCotizacionesOtrosProveedores,
        rows: [],
      },

      mostrarTotales: "",

      mostrarModificarSubproducto: false,
      idItemCotizacionActualizarSubproducto: -1,
      idSubproductoActualizarSubproducto: -1,
      respuestaSubproductos: "",

      cantidad: 0,
    };
  }
  componentDidMount() {
    this.cargarCotizacion();
    this.cargarProductos();
    this.cargarCategoriaProductoCotizacionValor();
    this.mensajeCargarArchivo();
    this.actualizarVisto();
    this.cargarVisualizacionBotonSimuladorEntidad();

    this.cargarSimulacionesProveedores();
    this.cargarMarcasProveedor();
  }

  handleChangeCant = (event) => {
    let value = event.target.value;

    // Verifica que el valor no sea negativo
    if (value >= 0) {
      this.setState({ cantidad: value });
    } else {
      this.setState({ cantidad: 0 });
    }
  };

  render() {
    return (
      <>
        <div
          class="menu"
          style={{
            backgroundColor: "#dbe7fc",
            width: "100%",
            padding: "10px",
            fontSize: "12px",
          }}
        >
          <div class="container">
            <InicioBreadcrumbs></InicioBreadcrumbs> /{" "}
            <Link to="/cotizaciones">Cotizaciones</Link> / Cotizacion:{" "}
            {this.state.simulador.nombre} - {this.state.entidad.nombre}
          </div>
        </div>

        <div
          class="container"
          style={{ minHeight: "550px", paddingTop: "30px" }}
        >
          <div class="subitulosPaginaNotificaciones">
            <b>
              Cotización: {this.state.simulador.nombre} -{" "}
              {this.state.entidad.nombre}
            </b>
          </div>
          <br />

          <div class="row">
            <div class="col-xl-2 col-lg-2 col-md-1 col-sm-12 col-xs-12"></div>
            <div
              class="col-xl-8 col-lg-8 col-md-10 col-sm-12 col-xs-12"
              style={{
                display: this.state.mostrarErrores,
                borderColor: "#a18706",
                backgroundColor: "#faf200",
                color: "#a18706",
                padding: "25px",
                textAlign: "center",
              }}
            >
              {this.state.mensajeErrores}
            </div>
            <div class="col-xl-2 col-lg-2 col-md-1 col-sm-12 col-xs-12"></div>
          </div>

          <div class="row">
            <div class="col-xl-2 col-lg-2 col-md-1 col-sm-12 col-xs-12"></div>
            <div
              class="col-xl-8 col-lg-8 col-md-10 col-sm-12 col-xs-12"
              style={{
                display: this.state.mostrarErroresEventoCotizacion,
                borderColor: "#f54b42",
                backgroundColor: "#f29b96",
                color: "#c91a10",
                padding: "25px",
                textAlign: "center",
              }}
            >
              El evento de cotización fue cancelado
              <br />
              {this.state.mensajesErroresEventoCotizacion}
            </div>
            <div class="col-xl-2 col-lg-2 col-md-1 col-sm-12 col-xs-12"></div>
          </div>
          <br />

          <div style={{ display: this.state.mostrarBotones }}>
            <div class="row">
              <div
                class="col-xl-3 col-lg-3 col-md-4 col-sm-12 col-xs-12"
                style={{
                  marginBottom: "20px",
                  display:
                    this.state.visualizacionBotonSimuladorProveedor
                      .insertarArchivo,
                }}
              >
                <Button
                  variant="primary"
                  style={{ width: "100%" }}
                  onClick={this.handleShowInsertarArchivoProveedorProcesoSimulacion.bind(
                    this
                  )}
                >
                  <i class="fas fa-plus-circle"></i> Subir archivo
                </Button>
              </div>

              <div
                class="col-xl-3 col-lg-3 col-md-4 col-sm-12 col-xs-12"
                style={{
                  marginBottom: "20px",
                  display: this.state.mostrarInsertarProducto,
                }}
              >
                <Button
                  variant="primary"
                  style={{ width: "100%" }}
                  onClick={this.handleAbrirInsertarProducto.bind(this)}
                >
                  <i class="fas fa-plus-circle"></i> Insertar producto
                </Button>
              </div>

              <div
                class="col-xl-3 col-lg-3 col-md-4 col-sm-12 col-xs-12"
                style={{
                  marginBottom: "20px",
                  display:
                    this.state.visualizacionBotonSimuladorProveedor
                      .ivaTodosProductos,
                }}
              >
                <Button
                  variant="primary"
                  style={{ width: "100%" }}
                  onClick={this.handleShowModificarIVATodosProductos.bind(this)}
                >
                  <i class="fas fa-percentage"></i> IVA todos productos
                </Button>
              </div>

              <div
                class="col-xl-3 col-lg-3 col-md-4 col-sm-12 col-xs-12"
                style={{
                  marginBottom: "20px",
                  display:
                    this.state.visualizacionBotonSimuladorProveedor
                      .descuentoTodosProductos,
                }}
              >
                <Button
                  variant="primary"
                  style={{ width: "100%" }}
                  onClick={this.handleShowModificarDescuentoTodosProductos.bind(
                    this
                  )}
                >
                  <i class="fas fa-tag"></i> Descuento todos productos
                </Button>
              </div>

              <div
                class="col-xl-3 col-lg-3 col-md-4 col-sm-12 col-xs-12"
                style={{
                  marginBottom: "20px",
                  display:
                    this.state.visualizacionBotonSimuladorProveedor
                      .descuentoCategoria,
                }}
              >
                <Button
                  variant="primary"
                  style={{ width: "100%" }}
                  onClick={this.handleShowInsertarCategoriaProductoCotizacionValor.bind(
                    this
                  )}
                >
                  <i class="fas fa-tag"></i> Descuento categoría
                </Button>
              </div>

              <div
                class="col-xl-3 col-lg-3 col-md-4 col-sm-12 col-xs-12"
                style={{
                  marginBottom: "20px",
                  display:
                    this.state.visualizacionBotonSimuladorProveedor
                      .cargueMasivoDescuento,
                }}
              >
                <Button
                  variant="primary"
                  style={{ width: "100%" }}
                  onClick={this.descargarFormatoDescuento.bind(this)}
                >
                  <i class="far fa-file-excel"></i> Formato cotizacion descuento
                </Button>
              </div>
              <div
                class="col-xl-3 col-lg-3 col-md-4 col-sm-12 col-xs-12"
                style={{
                  marginBottom: "20px",
                  display:
                    this.state.visualizacionBotonSimuladorProveedor
                      .cargueMasivoDescuento,
                }}
              >
                <Button
                  variant="primary"
                  style={{ width: "100%" }}
                  onClick={this.subirCotizacion.bind(this)}
                >
                  <i class="fas fa-upload"></i> Subir cotizacion descuento
                </Button>
              </div>

              <div
                class="col-xl-3 col-lg-3 col-md-4 col-sm-12 col-xs-12"
                style={{
                  marginBottom: "20px",
                  display:
                    this.state.visualizacionBotonSimuladorProveedor
                      .cargueMasivoPrecio,
                }}
              >
                <Button
                  variant="primary"
                  style={{ width: "100%" }}
                  onClick={this.descargarFormatoPrecio.bind(this)}
                >
                  <i class="far fa-file-excel"></i> Formato cotizacion precio
                </Button>
              </div>
              <div
                class="col-xl-3 col-lg-3 col-md-4 col-sm-12 col-xs-12"
                style={{
                  marginBottom: "20px",
                  display:
                    this.state.visualizacionBotonSimuladorProveedor
                      .cargueMasivoPrecio,
                }}
              >
                <Button
                  variant="primary"
                  style={{ width: "100%" }}
                  onClick={this.subirCargueMasivoPreciosPrecio.bind(this)}
                >
                  <i class="fas fa-upload"></i> Subir cotizacion precio
                </Button>
              </div>

              {/**								<div class="col-xl-3 col-lg-3 col-md-4 col-sm-12 col-xs-12" style={{marginBottom: '20px', display: this.state.mostrarDatosMontoAgotable}}>
									<Button variant="primary" style = {{width: "100%"}} onClick={ this.handleModificarCantidadOfertada.bind(this) }>
							        	<i class="fas fa-tag"></i> Modificar cantidad ofertada
							      	</Button>
								</div>
								<div class="col-xl-3 col-lg-3 col-md-4 col-sm-12 col-xs-12" style={{marginBottom: '20px', display: this.state.mostrarDatosMontoAgotable}}>
									<Button variant="primary" style = {{width: "100%"}} onClick={ this.handleShowModificarDescuentoTodosProductos.bind(this) }>
							        	<i class="fas fa-tag"></i> Modificar descuento
							      	</Button>
								</div>
								<div class="col-xl-3 col-lg-3 col-md-4 col-sm-12 col-xs-12" style={{marginBottom: '20px', display: this.state.mostrarDatosMontoAgotable}}>
									<Button variant="primary" style = {{width: "100%"}} onClick={ this.handleModificarCantidadOfertada.bind(this) }>
							        	<i class="fas fa-tag"></i> Modificar IVA 
							      	</Button>
								</div>
								
								  */}

              <div
                class="col-xl-3 col-lg-3 col-md-4 col-sm-12 col-xs-12"
                style={{ marginBottom: "20px" }}
              >
                <Button
                  variant="primary"
                  style={{ width: "100%" }}
                  onClick={this.handleShowEnviarCotizacion.bind(this)}
                >
                  <i class="fas fa-paper-plane"></i> Enviar cotización
                </Button>
              </div>
              <div
                class="col-xl-3 col-lg-3 col-md-4 col-sm-12 col-xs-12"
                style={{ marginBottom: "20px" }}
              >
                <Button
                  variant="primary"
                  style={{ width: "100%" }}
                  onClick={this.handleShowCerrarCotizacion.bind(this)}
                >
                  <i class="fas fa-check-double"></i> Última oferta
                </Button>
              </div>
            </div>
          </div>

          <br />

          <div class="fila">
            <div
              class="col-lg-7 col-md-7 col-sm-12 mr-auto"
              style={{ paddingLeft: "10px !important" }}
            >
              <br />
              <table class="table table-bordered table-hover table-sm table-striped dataTable">
                <thead>
                  <tr>
                    <th colSpan="2">Datos</th>
                  </tr>
                </thead>
                <tbody data-test="table-body">
                  <tr>
                    <td width="40%">Simulador</td>
                    <td width="60%">{this.state.nombreSimulador}</td>
                  </tr>
                  <tr>
                    <td>Consecutivo cotización</td>
                    <td>{this.state.consecutivoCotizacion}</td>
                  </tr>
                  <tr>
                    <td>Consecutivo proceso simulación</td>
                    <td>{this.state.consecutivoProcesoSimulacion}</td>
                  </tr>
                  <tr>
                    <td>Fecha máxima de respuesta</td>
                    <td>{this.state.fechaRespuesta}</td>
                  </tr>
                  <tr>
                    <td>Nombre tipo del simulador</td>
                    <td>{this.state.nombreTipoSimulador}</td>
                  </tr>
                  <tr>
                    <td>Catálogo</td>
                    <td>{this.state.nombreCatalogo}</td>
                  </tr>
                  <tr>
                    <td>Entidad</td>
                    <td>{this.state.nombreEntidad}</td>
                  </tr>
                  <tr>
                    <td>Estado envio</td>
                    <td>{this.state.estadoEnvio}</td>
                  </tr>
                  <tr style={{ display: this.state.mostrarDatosMontoAgotable }}>
                    <td>Presupuesto</td>
                    <td>{this.state.spresupuesto}</td>
                  </tr>
                  {/** 
									<tr style = { { display: this.state.mostrarDatosMontoAgotable } }>
										<td>IVA</td>
										<td>{ this.state.ivaCantidad  }</td>
									</tr>
									
									
									<tr style = { { display: this.state.mostrarDatosMontoAgotable } }>
										<td>Valor antes de IVA</td>
										<td>{ this.state.valorAntesIVACantidad }</td>
									</tr>
									
									<tr style = { { display: this.state.mostrarDatosMontoAgotable } }>
										<td>Descuento</td>
										<td>{ this.state.descuentoCantidad }</td>
									</tr>
									*/}

                  <tr style={{ display: this.state.mostrarDatosMontoAgotable }}>
                    <td>Cantidad oferta</td>
                    <td>{this.state.cantidadOferta}</td>
                  </tr>

                  <tr>
                    <td>Evento cotización</td>
                    <td>{this.state.consecutivoEventoCotizacion}</td>
                  </tr>
                  <tr>
                    <td>Nombre contacto</td>
                    <td>{decodeURIComponent(this.state.nombreContacto)}</td>
                  </tr>
                  <tr>
                    <td>Correo contacto</td>
                    <td>{decodeURIComponent(this.state.correoContacto)}</td>
                  </tr>
                  <tr>
                    <td>Teléfono contacto</td>
                    <td>{this.state.telefonoContacto}</td>
                  </tr>
                  <tr>
                    <td colspan="2">
                      <i>
                        El único canal de comunicación válido en los eventos de
                        cotización es el chat de mensajes. En caso que la
                        entidad compradora reciba mensajes de proveedores
                        mediante correo electrónico u otro canal, deberá
                        explicarlos dentro del chat de mensajes.
                      </i>
                    </td>
                  </tr>

                  {this.state.datosExtras}
                </tbody>
              </table>
            </div>
            <div
              class="col-lg-5 col-md-5 col-sm-12 mr-auto"
              style={{ paddingLeft: "10px !important" }}
            >
              <br />
              <MDBDataTableV5
                striped
                bordered
                small
                data={this.state.gravamenesSimulacion}
                hover
                entries={1000}
                fullPagination={false}
                paging={false}
                info={false}
                pagingTop={false}
                pagingBottom={false}
                searchBottom={false}
                searchTop={false}
                sortable={false}
                condensed
              />
            </div>
          </div>

          <br />
          <br />

          <Tabs>
            <Tab eventKey="items" title="Items">
              {this.state.cargandoItemsCotizacion}
              <div style={{ whiteSpace: "pre-wrap" }}>
                <br />
                <MDBDataTable
                  striped
                  bordered
                  small
                  data={this.state.datos}
                  hover
                  entriesOptions={[5, 10, 25, 100, 1000]}
                  entries={400}
                  pagesAmount={20}
                  condensed
                />

                <br />
                <br />
                <div
                  class="fila"
                  style={{ display: this.state.mostrarTotales }}
                >
                  <div class="col-lg-6 col-md-6 col-sm-12 mr-auto"></div>
                  <div
                    class="col-lg-6 col-md-6 col-sm-12 mr-auto"
                    style={{ paddingLeft: "10px !important" }}
                  >
                    <table class="table table-bordered table-hover table-sm table-striped dataTable">
                      <tbody data-test="table-body">
                        <tr>
                          <td width="35%">Subtotal:</td>
                          <td width="65%">{this.state.cotizacion.ssubtotal}</td>
                        </tr>

                        <tr>
                          <td width="35%">Total IVA:</td>
                          <td width="65%">{this.state.cotizacion.stotalIVA}</td>
                        </tr>
                        <tr>
                          <td width="35%">Total Descuento:</td>
                          <td width="65%">
                            {this.state.cotizacion.stotalDescuento}
                          </td>
                        </tr>

                        <tr>
                          <td width="35%">Total:</td>
                          <td width="65%">{this.state.cotizacion.stotal}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <br />
                <br />
              </div>
            </Tab>
            <Tab eventKey="misArvhivos" title="Mis archivos">
              <div style={{ whiteSpace: "pre-wrap" }}>
                <br />
                <MDBDataTable
                  striped
                  bordered
                  small
                  data={this.state.archivos}
                  hover
                  entriesOptions={[5, 10, 25, 100, 1000]}
                  entries={100}
                  pagesAmount={20}
                  condensed
                />
              </div>
            </Tab>
            <Tab eventKey="arvhivosEntidad" title="Archivos entidad">
              <div style={{ whiteSpace: "pre-wrap" }}>
                <br />
                <MDBDataTable
                  striped
                  bordered
                  small
                  data={this.state.datosArchivosSimulacion}
                  hover
                  entriesOptions={[5, 10, 25, 100, 1000]}
                  entries={100}
                  pagesAmount={20}
                  condensed
                />
              </div>
            </Tab>

            <Tab
              eventKey="descuentoPorCategoriaProducto"
              title="Descuento por categoría de producto"
              tabClassName={
                this.state.visualizacionBotonSimuladorProveedor
                  .descuentoCategoria === "none"
                  ? "d-none"
                  : ""
              }
            >
              <div style={{ whiteSpace: "pre-wrap" }}>
                <br />
                <MDBDataTable
                  striped
                  bordered
                  small
                  data={this.state.datosCategoriasProducto}
                  hover
                  entriesOptions={[5, 10, 25, 100, 1000]}
                  entries={100}
                  pagesAmount={20}
                  condensed
                />
              </div>
            </Tab>

            <Tab eventKey="simulaciones" title="Simulaciones">
              <div style={{ whiteSpace: "pre-wrap" }}>
                <br />
                <MDBDataTable
                  striped
                  bordered
                  small
                  data={this.state.simulaciones}
                  hover
                  entriesOptions={[5, 10, 25, 100, 1000]}
                  entries={100}
                  pagesAmount={20}
                  condensed
                />
              </div>
            </Tab>

            <Tab
              eventKey="cotizaciones"
              title="Respuestas"
              disabled={this.state.puedeVerCotizaciones}
            >
              <div style={{ whiteSpace: "pre-wrap" }}>
                <br />
                <OfertaTodosProveedores
                  idCotizacion={this.state.idCotizacion}
                />
              </div>
            </Tab>
          </Tabs>

          <br />
          <br />

          <div
            style={{
              display: this.state.mostrarMensajeCargando,
              position: "fixed",
              left: "50px",
              top: "210px",
              backgroundColor: this.state.colorMensajeCargando,
              color: "white",
              width: "210px",
              verticalAlign: "middle",
              textAlign: "center",
              fontSize: "14px",
              padding: "10px",
              zIndex: "998",
            }}
          >
            {this.state.mensajeCargandoArchivo}
          </div>

          <div
            style={{
              position: "fixed",
              right: "50px",
              top: "210px",
              backgroundColor: this.state.colorContador,
              color: "white",
              width: "180px",
              height: "90px",
              verticalAlign: "middle",
              textAlign: "center",
              fontSize: "21px",
              paddingTop: "10px",
              zIndex: "998",
            }}
          >
            <div style={{ display: this.state.mensajeContador }}>
              <span style={{ fontSize: "18px" }}>
                {this.state.diasCuentaRegresiva}D{" "}
                {this.state.horasCuentaRegresiva}H{" "}
                {this.state.minutosCuentaRegresiva}M
              </span>
              <br />
              <span style={{ fontSize: "12px" }}>
                {this.state.fechaRespuesta}
              </span>
            </div>
            <div style={{ display: this.state.mensajeContadorVencido }}>
              <div style={{ height: "15px" }}></div>
              <span style={{ fontSize: "18px" }}>Conteo finalizado</span>
            </div>
          </div>

          <ChatSimulacion
            titulo={
              (this.state.simulador ? this.state.simulador.nombre : "") +
              " - " +
              (this.state.entidad ? this.state.entidad.nombre : "")
            }
            referencia={{ campo: "idCotizacion", valor: this.state.idCotizacion }}
            tipoUsuarioPropio={2}
            idUsuarioPropio={this.idUsuarioActual}
            urlBase={misConstantes.URL_CONSULTA}
            servlets={{
              mensajes: "ServletChatMensajesCotizacion",
              insertar: "ServletInsertarMensaje",
              archivo: "ServletInsertarArchivoChat",
              reenviar: "ServletReenviarCorreoMensaje",
            }}
            claveCodigoUsuario="simuladores.proveedores.codigoUsuario"
          />

              {/**
				// ------------------------------------------------------------------------------------------------------
				// CategoriaProductoCotizacionValor
				// ------------------------------------------------------------------------------------------------------
				 */}

              <Modal
                show={
                  this.state.mostrarInsertarCategoriaProductoCotizacionValor
                }
                onHide={this.handleCloseInsertarCategoriaProductoCotizacionValor.bind(
                  this
                )}
              >
                <Modal.Header closeButton>
                  <Modal.Title>Insertar descuento por categoría</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <form>
                    Categoría producto
                    <br />
                    <select
                      class="form-control"
                      id={"categoriaProductoInsertarDescuentoCategoria"}
                    ></select>
                    <br />
                    Valor
                    <br />
                    <input
                      type="text"
                      id="valorProductoInsertarDescuentoCategoria"
                      className="form-control"
                      placeholder="% de descuento pot valor, ej 10"
                    />
                    <br />
                    <br />
                    {
                      this.state
                        .respuestaInsertarCategoriaProductoCotizacionValor
                    }
                  </form>
                </Modal.Body>
                <Modal.Footer>
                  <Button
                    variant="secondary"
                    onClick={this.handleCloseInsertarCategoriaProductoCotizacionValor.bind(
                      this
                    )}
                  >
                    Cerrar
                  </Button>
                  <Button
                    variant="primary"
                    onClick={this.insertarCategoriaProductoCotizacionValor.bind(
                      this
                    )}
                  >
                    Insertar
                  </Button>
                </Modal.Footer>
              </Modal>

              <Modal
                show={this.state.mostrarEditarCategoriaProductoCotizacionValor}
                onHide={this.handleCloseEditarCategoriaProductoCotizacionValor.bind(
                  this
                )}
              >
                <Modal.Header closeButton>
                  <Modal.Title>
                    Editar categoriaProductoCotizacionValor
                  </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <form>
                    <input
                      type="hidden"
                      value={
                        this.state.idCategoriaProductoCotizacionValorEditar
                      }
                    />
                    Valor
                    <br />
                    <input
                      type="text"
                      id="valorEditarCategoriaProductoCotizacionValor"
                      className="form-control"
                      placeholder="Valor del categoriaProductoCotizacionValor"
                    />
                    <br />
                    {this.state.respuestaEditarCategoriaProductoCotizacionValor}
                  </form>
                </Modal.Body>
                <Modal.Footer>
                  <Button
                    variant="secondary"
                    onClick={this.handleCloseEditarCategoriaProductoCotizacionValor.bind(
                      this
                    )}
                  >
                    Cerrar
                  </Button>
                  {/** <Button variant="primary"  onClick = { this.editarCategoriaProductoCotizacionValor.bind( this ) }>Editar</Button>*/}
                </Modal.Footer>
              </Modal>

              <Modal
                show={
                  this.state.mostrarEliminarCategoriaProductoCotizacionValor
                }
                onHide={this.handleCloseEliminarCategoriaProductoCotizacionValor.bind(
                  this
                )}
              >
                <Modal.Header closeButton>
                  <Modal.Title>Eliminar categoría producto</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <input
                    type="hidden"
                    value={
                      this.state.idEliminarCategoriaProductoCotizacionValor
                    }
                  />
                  ¿Seguro quiere eliminar{" "}
                  {this.state.nombreEliminarCategoriaProductoCotizacionValor}?
                  <br />
                  {this.state.respuestaEliminarCategoriaProductoCotizacionValor}
                </Modal.Body>
                <Modal.Footer>
                  <Button
                    variant="secondary"
                    onClick={this.handleCloseEliminarCategoriaProductoCotizacionValor.bind(
                      this
                    )}
                  >
                    Cerrar
                  </Button>
                  <Button
                    variant="danger"
                    onClick={this.eliminarCategoriaProductoCotizacionValor.bind(
                      this
                    )}
                  >
                    Eliminar
                  </Button>
                </Modal.Footer>
              </Modal>

          {/**
				// ------------------------------------------------------------------------------------------------------
				// ItemCotizacion
				// ------------------------------------------------------------------------------------------------------
				 */}

          <Modal
            show={this.state.mostrarActualizarModificarCantidad}
            onHide={this.handleCloseModificarCantidad.bind(this)}
          >
            <Modal.Header closeButton>
              <Modal.Title>Productos proveedor</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <form
                onSubmit={this.formularioModificarIVATodosProductos.bind(this)}
              >
                <br />
                {this.state.mensajeActualizarCantidadOfertada}
              </form>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                onClick={this.handleCloseModificarCantidad.bind(this)}
              >
                Cerrar
              </Button>
              <Button
                variant="primary"
                onClick={this.modificarCantidadOfertada.bind(this)}
              >
                Actualizar
              </Button>
            </Modal.Footer>
          </Modal>

          <Modal
            show={this.state.mostrarActualizarModificarCantidad}
            onHide={this.handleCloseModificarCantidad.bind(this)}
          >
            <Modal.Header closeButton>
              <Modal.Title>Modificar cantidad ofertada</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <form
                onSubmit={this.formularioModificarIVATodosProductos.bind(this)}
              >
                Cantidad ofertada
                <br />
                <input
                  type="text"
                  className="form-control"
                  placeholder="Cantidad ofertada"
                  id="cantidadOfertada_modificarCantidadOfertad"
                />
                <br />
                <br />
                {this.state.mensajeActualizarCantidadOfertada}
              </form>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                onClick={this.handleCloseModificarCantidad.bind(this)}
              >
                Cerrar
              </Button>
              <Button
                variant="primary"
                onClick={this.modificarCantidadOfertada.bind(this)}
              >
                Actualizar
              </Button>
            </Modal.Footer>
          </Modal>

          <Modal
            show={this.state.mostrarIVATodosProductos}
            onHide={this.handleCloseIVATodosProductos.bind(this)}
          >
            <Modal.Header closeButton>
              <Modal.Title>IVA todos los productos</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <form
                onSubmit={this.formularioModificarIVATodosProductos.bind(this)}
              >
                % de IVA
                <br />
                <input
                  type="text"
                  className="form-control"
                  placeholder="IVA todos productos"
                  value={this.state.ivaTodosProductosModificar}
                  onChange={this.ivaTodosProductosModificar.bind(this)}
                />
                <br />
                <br />
                {this.state.respuestaActualizacionMasiva}
              </form>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                onClick={this.handleCloseIVATodosProductos.bind(this)}
              >
                Cerrar
              </Button>
              <Button
                variant="primary"
                onClick={this.modificarIVATodosProductos.bind(this)}
              >
                Actualizar
              </Button>
            </Modal.Footer>
          </Modal>

          <Modal
            show={this.state.mostrarDescuentoTodosProductos}
            onHide={this.handleCloseDescuentoTodosProductos.bind(this)}
          >
            <Modal.Header closeButton>
              <Modal.Title>Descuento todos los productos</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <form
                onSubmit={this.formularioModificarDescuentoTodosProductos.bind(
                  this
                )}
              >
                Descuento
                <br />
                <input
                  type="text"
                  className="form-control"
                  placeholder="Descuento todos productos"
                  value={this.state.descuentoTodosProductos}
                  onChange={this.descuentoTodosProductosModificar.bind(this)}
                />
                <br />
                <br />
                {this.state.respuestaActualizacionMasiva}
              </form>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                onClick={this.handleCloseDescuentoTodosProductos.bind(this)}
              >
                Cerrar
              </Button>
              <Button
                variant="primary"
                onClick={this.modificarDescuentoTodosProductos.bind(this)}
              >
                Actualizar
              </Button>
            </Modal.Footer>
          </Modal>

          <Modal
            show={this.state.mostrarEnviarCotizacion}
            onHide={this.handleCloseEnviarCotizacion.bind(this)}
          >
            <Modal.Header closeButton>
              <Modal.Title>Enviar cotización</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              ¿Seguro quiere enviar cotizacion?.
              <br />
              {this.state.respuestaCerrarCotizacion}
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                onClick={this.handleCloseCerrarCotizacion.bind(this)}
              >
                Cerrar
              </Button>
              <Button
                variant="primary"
                onClick={this.cerrarCotizacion.bind(this)}
              >
                Enviar
              </Button>
            </Modal.Footer>
          </Modal>

          <Modal
            show={this.state.mostrarCerrarCotizacion}
            onHide={this.handleCloseCerrarCotizacion.bind(this)}
          >
            <Modal.Header closeButton>
              <Modal.Title>Ultima oferta</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              ¿Esta es su última oferta?, si la envía, despues no podrá realizar
              ningún cambio adicional.
              <br />
              {this.state.respuestaCerrarCotizacion}
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                onClick={this.handleCloseCerrarCotizacion.bind(this)}
              >
                Cerrar
              </Button>
              <Button
                variant="primary"
                onClick={this.cerrarCotizacion.bind(this)}
              >
                Enviar
              </Button>
            </Modal.Footer>
          </Modal>

          <Modal
            show={this.state.mostrarEnviarCotizacion}
            onHide={this.handleCloseEnviarCotizacion.bind(this)}
          >
            <Modal.Header closeButton>
              <Modal.Title>Enviar cotización</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              ¿Seguro quiere enviar la cotización?.
              <br />
              {this.state.mensajeRespuestaEnviarCotizacion}
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                onClick={this.handleCloseEnviarCotizacion.bind(this)}
              >
                Cerrar
              </Button>
              <Button
                variant="primary"
                onClick={this.enviarCotizacion.bind(this)}
              >
                Enviar
              </Button>
            </Modal.Footer>
          </Modal>

          <Modal
            show={this.state.mostrarEditarItemCotizacion}
            onHide={this.handleCloseEditarItemCotizacion.bind(this)}
          >
            <Modal.Header closeButton>
              <Modal.Title>Editar item</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <form onSubmit={this.formularioEditarItemCotizacion.bind(this)}>
                <div style={{ display: this.state.mostrarPresentarseLinea }}>
                  Presentar producto en oferta
                  <br />
                  <select id="presentoLinea" class="form-control">
                    <option value="1">SI</option>
                    <option value="0">NO</option>
                  </select>
                  <br />
                </div>
                <div
                  style={{
                    display: this.state.mostrarDescuentoValorActualizarItem,
                  }}
                >
                  Precio unitario antes impuestos
                  <br />
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Precio unitario antes impuestos"
                    value={this.state.precioUnitarioAntesImpuestos}
                    onChange={this.actualizarPrecioUnitarioAntesImpuestosEditar.bind(
                      this
                    )}
                  />
                  <br />
                  <div
                    style={{
                      display: this.state.requiereEdicionProveedor
                        ? "none"
                        : this.state.mostrarDescuento,
                    }}
                  >
                    Porcentaje descuento
                    <br />
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Descuento del itemCotizacion"
                      value={this.state.descuentoPorcentaje}
                      onChange={this.descuentoPorcentajeEditar.bind(this)}
                    />
                    <br />
                  </div>
                </div>
                <div
                  style={{
                    display: this.state.mostrarValorCatalogoActualizarItem,
                  }}
                >
                  Valor catálogo
                  <br />
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Valor catalogo"
                    value={this.state.valorCatalogo}
                    onChange={this.actualizarValorCatalogo.bind(this)}
                  />
                  <br />
                  IVA
                  <input
                    type="text"
                    className="form-control"
                    placeholder="IVA"
                    value={this.state.IVAvalorCatalogo}
                    onChange={this.actualizarIVAValorCatalogo.bind(this)}
                  />
                  <br />
                </div>

                <div
                  style={{
                    display: this.state.mostrarDescuentoValorActualizarItem,
                  }}
                >
                  IVA
                  <br />
                  <input
                    type="text"
                    className="form-control"
                    placeholder="IVA"
                    value={this.state.ivaEditar}
                    onChange={this.actualizarIVAEditar.bind(this)}
                  />
                  <br />
                  Valor IVA unitario
                  <br />
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Valor IVA unitario"
                    value={this.state.valorIVAEditar}
                    onChange={this.actualizarValorIVAEditar.bind(this)}
                  />
                  <br />
                </div>

                <div style={{ display: this.state.visualizacionOfertada }}>
                  Cantidad ofertada
                  <br />
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Cantidad ofertada"
                    value={this.state.cantidadOfertada}
                    onChange={this.actualizarCantidadOfertada.bind(this)}
                  />
                  <br />
                </div>
                <br />
                {this.state.respuestaEditarItemCotizacion}
              </form>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                onClick={this.handleCloseEditarItemCotizacion.bind(this)}
              >
                Cerrar
              </Button>
              <Button
                variant="primary"
                onClick={this.editarItemCotizacion.bind(this)}
              >
                Editar
              </Button>
            </Modal.Footer>
          </Modal>

          <Modal
            show={this.state.mostrarEditarItemCotizacionOfertado}
            onHide={this.handleCloseEditarItemOfertado.bind(this)}
          >
            <Modal.Header closeButton>
              <Modal.Title>Editar item abierto</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <form onSubmit={this.formularioEditarItemCotizacion.bind(this)}>
                Item a ofertar
                <br />
                <div style={{ whiteSpace: "pre-wrap" }}>
                  <Select
                    options={this.state.productosAbiertos}
                    onChange={this.modificarItemOfertar.bind(this)}
                    setValue={this.state.itemOfertarProveedor}
                    value={this.state.itemOfertarProveedor}
                  />
                  <br />
                </div>
                Precio unitario antes impuestos
                <br />
                <input
                  type="text"
                  className="form-control"
                  placeholder="Precio unitario antes impuestos"
                  value={this.state.precioUnitarioAntesImpuestos}
                  onChange={this.actualizarPrecioUnitarioAntesImpuestosEditar.bind(
                    this
                  )}
                />
                <br />
                IVA
                <br />
                <input
                  type="text"
                  className="form-control"
                  placeholder="IVA"
                  value={this.state.ivaEditar}
                  onChange={this.actualizarIVAEditar.bind(this)}
                />
                <br />
                Valor IVA unitario
                <br />
                <input
                  type="text"
                  className="form-control"
                  placeholder="Valor IVA unitario"
                  value={this.state.valorIVAEditar}
                  onChange={this.actualizarValorIVAEditar.bind(this)}
                />
                <br />
                <br />
                {this.state.mensajeModificarValoresOfertado}
              </form>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                onClick={this.handleCloseEditarItemOfertado.bind(this)}
              >
                Cerrar
              </Button>
              <Button
                variant="primary"
                onClick={this.editarItemCotizacionOfertado.bind(this)}
              >
                Editar
              </Button>
            </Modal.Footer>
          </Modal>

          <Modal
            show={this.state.mostrarEditarItemCotizacionAbierto}
            onHide={this.handleCloseEditarItemCotizacionAbierto.bind(this)}
          >
            <Modal.Header closeButton>
              <Modal.Title>Actualizar item</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <form onSubmit={this.formularioEditarItemCotizacion.bind(this)}>
                IVA en porcentaje (%)
                <br />
                <input
                  type="text"
                  className="form-control"
                  placeholder="IVA en porcentaje (%)"
                  id={"ivaModificarItemAbierto"}
                />
                <br />
                Precio unitario antes impuestos
                <br />
                <input
                  type="text"
                  className="form-control"
                  placeholder="Precio unitario antes impuestos"
                  id={"precioUnitarioModificarItemAbierto"}
                />
                <br />
                <br />
                {this.state.mensajeModificarValoresAbierto}
              </form>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                onClick={this.handleCloseEditarItemCotizacionAbierto.bind(this)}
              >
                Cerrar
              </Button>
              <Button
                variant="primary"
                onClick={this.actualizarItemAbierto.bind(this)}
              >
                Editar
              </Button>
            </Modal.Footer>
          </Modal>

          <Modal
            show={this.state.mostrarDialogoInsertarProducto}
            onHide={this.handleCloseInsertarProducto.bind(this)}
          >
            <Modal.Header closeButton>
              <Modal.Title>Insertar producto</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <form onSubmit={this.formularioEditarItemCotizacion.bind(this)}>
                Producto
                <br />
                <Select
                  options={this.state.productosProveedor}
                  onChange={this.modificarProductoInsertarProducto.bind(this)}
                  setValue={this.state.productoProveedorProductoInsertar}
                  value={this.state.productoProveedorProductoInsertar}
                />
                <br />
                <div
                  style={{
                    display: this.state.mostrarCantidadInsertarProducto,
                  }}
                >
                  Cantidad
                  <br />
                  <input
                    type="number"
                    min="0"
                    id="cantidadInsertarProducto"
                    className={"form-control"}
                    value={this.state.cantidad}
                    onChange={this.handleChangeCant}
                  />
                  <br />
                </div>
                IVA
                <br />
                <input
                  type="number"
                  id="ivaInsertarProducto"
                  className={"form-control"}
                />
                <div
                  style={{ display: this.state.simulador.rfi ? "none" : "" }}
                >
                  Descuento
                  <br />
                  <input
                    type="number"
                    id="descuentoInsertarProducto"
                    className={"form-control"}
                  />
                </div>
                <br />
                {this.state.mensajeInsertarProducto}
                <br />
                {this.state.mensajeModificarValoresAbierto}
              </form>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                onClick={this.handleCloseInsertarProducto.bind(this)}
              >
                Cerrar
              </Button>
              <Button
                variant="primary"
                onClick={this.insertarProductoProveedorProducto.bind(this)}
              >
                Insertar
              </Button>
            </Modal.Footer>
          </Modal>

          <Modal
            show={this.state.mostrarEditarItemCotizacionPiso}
            onHide={this.handleCloseEditarItemCotizacionPiso.bind(this)}
          >
            <Modal.Header closeButton>
              <Modal.Title>Actualizar item</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <form onSubmit={this.formularioEditarItemCotizacion.bind(this)}>
                Cantidad
                <br />
                <input
                  type="text"
                  min="0"
                  className="form-control"
                  placeholder="Cantidad"
                  id={"cantidadModificarItemPiso"}
                  value={this.state.cantidad}
                  onChange={this.handleChangeCant}
                />
                <br />
                <br />
                {this.state.mensajeModificarValoresAbierto}
              </form>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                onClick={this.handleCloseEditarItemCotizacionAbierto.bind(this)}
              >
                Cerrar
              </Button>
              <Button
                variant="primary"
                onClick={this.actualizarItemAbierto.bind(this)}
              >
                Editar
              </Button>
            </Modal.Footer>
          </Modal>

          {/**
				// ------------------------------------------------------------------------------------------------------
				// Archivos
				// ------------------------------------------------------------------------------------------------------
				 */}

          <Modal
            show={this.state.mostrarInsertarArchivoProveedorProcesoSimulacion}
            onHide={this.handleCloseInsertarArchivoProveedorProcesoSimulacion.bind(
              this
            )}
          >
            <Modal.Header closeButton>
              <Modal.Title>Insertar archivo</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <form
                onSubmit={this.formularioInsertarArchivoProveedorProcesoSimulacion.bind(
                  this
                )}
              >
                Archivo
                <br />
                <input
                  type="file"
                  name="file"
                  onChange={(event) => this.changeHandlerArchivoPrecio(event)}
                />
                <br />
                <br />
                <div>
                  <p>Filename: {this.state.selectedFile.name}</p>
                  <p>Filetype: {this.state.selectedFile.type}</p>
                  <p>Size in bytes: {this.state.selectedFile.size}</p>
                </div>
                Descripción
                <br />
                <textarea
                  className="form-control"
                  placeholder="Descripción del archivo"
                  value={
                    this.state
                      .descripcionInsertarArchivoProveedorProcesoSimulacion
                  }
                  onChange={this.insertarDescripcionInsertarArchivoProveedorProcesoSimulacion.bind(
                    this
                  )}
                ></textarea>
                <br />
                {this.state.respuestaInsertarArchivoProveedorProcesoSimulacion}
              </form>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                onClick={this.handleCloseInsertarArchivoProveedorProcesoSimulacion.bind(
                  this
                )}
              >
                Cerrar
              </Button>
              <Button
                variant="primary"
                onClick={this.insertarArchivoProveedorProcesoSimulacion.bind(
                  this
                )}
              >
                Insertar
              </Button>
            </Modal.Footer>
          </Modal>

          <Modal
            show={this.state.mostrarEditarArchivoProveedorProcesoSimulacion}
            onHide={this.handleCloseEditarArchivoProveedorProcesoSimulacion.bind(
              this
            )}
          >
            <Modal.Header closeButton>
              <Modal.Title>Editar archivo</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <form
                onSubmit={this.formularioEditarArchivoProveedorProcesoSimulacion.bind(
                  this
                )}
              >
                <input
                  type="hidden"
                  value={this.state.idArchivoProveedorProcesoSimulacionEditar}
                />
                Descripción
                <br />
                {/**<input type = 'text'  className = 'form-control'  placeholder = 'Descripción del archivo' value = { this.state.descripcionEditarArchivoProveedorProcesoSimulacion } onChange = { this.modificarDescripcionEditarArchivoProveedorProcesoSimulacion.bind( this ) }/><br/> */}
                <textarea
                  className="form-control"
                  placeholder="Descripción del archivo"
                  value={
                    this.state
                      .descripcionEditarArchivoProveedorProcesoSimulacion
                  }
                  onChange={this.modificarDescripcionEditarArchivoProveedorProcesoSimulacion.bind(
                    this
                  )}
                ></textarea>
                {this.state.respuestaEditarArchivoProveedorProcesoSimulacion}
              </form>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                onClick={this.handleCloseEditarArchivoProveedorProcesoSimulacion.bind(
                  this
                )}
              >
                Cerrar
              </Button>
              <Button
                variant="primary"
                onClick={this.editarArchivoProveedorProcesoSimulacion.bind(
                  this
                )}
              >
                Editar
              </Button>
            </Modal.Footer>
          </Modal>

          <Modal
            show={this.state.mostrarEliminarArchivoProveedorProcesoSimulacion}
            onHide={this.handleCloseEliminarArchivoProveedorProcesoSimulacion.bind(
              this
            )}
          >
            <Modal.Header closeButton>
              <Modal.Title>Eliminar archivo</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <input
                type="hidden"
                value={this.state.idEliminarArchivoProveedorProcesoSimulacion}
              />
              ¿Seguro quiere eliminar{" "}
              {this.state.nombreEliminarArchivoProveedorProcesoSimulacion}?
              <br />
              {this.state.respuestaEliminarArchivoProveedorProcesoSimulacion}
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                onClick={this.handleCloseEliminarArchivoProveedorProcesoSimulacion.bind(
                  this
                )}
              >
                Cerrar
              </Button>
              <Button
                variant="danger"
                onClick={this.eliminarArchivoProveedorProcesoSimulacion.bind(
                  this
                )}
              >
                Eliminar
              </Button>
            </Modal.Footer>
          </Modal>
          <Modal
            show={this.state.mostrarEliminarItemCotizacionProcesoSimulacion}
            onHide={this.handleCloseEliminarItemProcesoSimulacion.bind(this)}
          >
            <Modal.Header closeButton>
              <Modal.Title>Eliminar item</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <input
                type="hidden"
                value={this.state.idEliminarItemCotizacionSimulacion}
              />
              ¿Seguro quiere eliminar {this.state.nombreItemEliminarCotizacion}?
              <br />
              {this.state.respuestaEliminarItemProcesoSimulacion}
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                onClick={this.handleCloseEliminarItemProcesoSimulacion.bind(
                  this
                )}
              >
                Cerrar
              </Button>
              <Button
                variant="danger"
                onClick={this.handleEliminarItemProcesoSimulacion.bind(this)}
              >
                Eliminar
              </Button>
            </Modal.Footer>
          </Modal>

          <Modal
            show={this.state.mostrarSubirPreciosMasivos}
            onHide={this.handleCloseCargueMasivoPrecios.bind(this)}
          >
            <Modal.Header closeButton>
              <Modal.Title>Subir masivo descuento/iva</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div>
                <br />
                Archivo descuentos
                <br />
                <input
                  type="file"
                  name="file"
                  onChange={(event) => this.changeHandlerArchivo(event)}
                />
                <br />
                <div>
                  <p>Filename: {this.state.archivoCotizacion.name}</p>
                  <p>Filetype: {this.state.archivoCotizacion.type}</p>
                  <p>Size in bytes: {this.state.archivoCotizacion.size}</p>
                </div>
                {this.state.respuestaSubirArchivoCargueMasivoPrecios}
                <div>
                  {/*											<button onClick={handleSubmission}>Submit</button> */}
                </div>
              </div>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                onClick={this.handleCloseCargueMasivoPrecios.bind(this)}
              >
                Cerrar
              </Button>
              <Button
                variant="primary"
                onClick={this.subirArchivoCargueMasivoDescuentos.bind(this)}
              >
                Subir
              </Button>
            </Modal.Footer>
          </Modal>

          <Modal
            show={this.state.mostrarSubirPreciosPrecioMasivos}
            onHide={this.handleCloseCargueMasivoPreciosPrecio.bind(this)}
          >
            <Modal.Header closeButton>
              <Modal.Title>Subir masivo precio/iva</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div>
                <br />
                Archivo precios
                <br />
                <input
                  type="file"
                  name="file"
                  onChange={(event) =>
                    this.changeHandlerArchivoPrecioFinal(event)
                  }
                />
                <br />
                <div>
                  <p>Filename: {this.state.archivoCotizacionPrecio.name}</p>
                  <p>Filetype: {this.state.archivoCotizacionPrecio.type}</p>
                  <p>
                    Size in bytes: {this.state.archivoCotizacionPrecio.size}
                  </p>
                </div>
                {this.state.respuestaSubirArchivoCargueMasivoPreciosPrecio}
                <div>
                  {/*											<button onClick={handleSubmission}>Submit</button> */}
                </div>
              </div>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                onClick={this.handleCloseCargueMasivoPreciosPrecio.bind(this)}
              >
                Cerrar
              </Button>
              <Button
                variant="primary"
                onClick={this.subirArchivoCargueMasivoPreciosPrecio.bind(this)}
              >
                Subir
              </Button>
            </Modal.Footer>
          </Modal>

          <Modal
            show={this.state.mostrarCambiarMarca}
            onHide={this.handleCloseCargaMarca.bind(this)}
          >
            <Modal.Header closeButton>
              <Modal.Title>Solicitar marca</Modal.Title>
            </Modal.Header>

            <Modal.Body>
              <div>
                {!this.state.esAdjudicacionMultiple &&
                  (console.log("Mostrando input de texto para Marca"),
                  (
                    <div>
                      Marca
                      <br />
                      <input
                        type="text"
                        id="marcaSolicitudMarca"
                        className="form-control"
                      />
                    </div>
                  ))}

                {this.state.esAdjudicacionMultiple &&
                  (console.log(
                    "Mostrando select de Marca para adjudicación múltiple"
                  ),
                  (
                    <div>
                      Marca
                      <br />
                      <select id="marcaSolicitudMarca" className="form-control">
                        <option value="">Seleccione una marca</option>
                        {this.state.marcasProveedor?.map((marca) => (
                          <option key={marca.value.value} value={marca.label}>
                            {marca.label}
                          </option>
                        ))}
                      </select>
                      <br />
                      Recuerde que para adjudicación múltiple la marca que elija
                      se aplicará para todos los ítems.
                    </div>
                  ))}

                <div>
                  <br />
                  Especificación
                  <br />
                  <input
                    type="text"
                    id="especificacionSolicitudMarca"
                    className="form-control"
                  />
                  <br />
                  {this.state.respuestaMarca}
                </div>
              </div>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                onClick={this.handleCloseCargaMarca.bind(this)}
              >
                Cerrar
              </Button>
              <div>
                <div
                  style={{
                    display: this.state.esAdjudicacionMultiple
                      ? "none"
                      : "block",
                  }}
                >
                  <Button
                    variant="primary"
                    onClick={this.actualizarMarca.bind(this)}
                  >
                    Guardar
                  </Button>
                </div>
                <div
                  style={{
                    display: this.state.esAdjudicacionMultiple
                      ? "block"
                      : "none",
                  }}
                >
                  <Button
                    variant="primary"
                    onClick={this.actualizarMarcaAdjudicacionMultiple.bind(
                      this
                    )}
                  >
                    Guardar
                  </Button>
                </div>
              </div>
            </Modal.Footer>
          </Modal>

          <Modal
            show={this.state.mostrarModificarSubproducto}
            onHide={this.handleCloseNombreSubproducto.bind(this)}
          >
            <Modal.Header closeButton>
              <Modal.Title>Modificar</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div>
                {this.state.nombreSubproducto}
                <br />
                <br />
                {/* IVA<br/>
										<input type = 'text' id = 'ivaSubproductoModificar' className = 'form-control'/><br/> */}
                Valor
                <br />
                <input
                  type="text"
                  id="valorSubproductoModificar"
                  className="form-control"
                />
                <br />
                {this.state.respuestaSubproductos}
              </div>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                onClick={this.handleCloseNombreSubproducto.bind(this)}
              >
                Cerrar
              </Button>
              <Button
                variant="primary"
                onClick={this.actualizarSubproducto.bind(this)}
              >
                Guardar
              </Button>
            </Modal.Footer>
          </Modal>
        </div>
      </>
    );
  }

  // ------------------------------------------------------------------------------------------------------
  // Marcas Proveedor
  // ------------------------------------------------------------------------------------------------------
  cargarMarcasProveedor(event) {
    var codigo = localStorage.getItem("simuladores.proveedores.codigoUsuario");
    var idCotizacion = this.state.idCotizacion;
    console.log(idCotizacion);
    var info = { codigo: codigo, idCotizacion: idCotizacion };

    axios
      .post(misConstantes.URL_CONSULTA + "/ServletMarcasProveedor", info, {
        params: info,
      })
      .then(
        function (response) {
          var res = response.data;
          console.log(res);
          var marcasProveedor = [];
          for (var i = 0; i < res.length; i++) {
            const id = res[i].id;
            const nombre = res[i].marca;
            console.log(id, nombre);
            var marca = {
              value: { value: id, label: nombre },
              label: nombre,
            };
            marcasProveedor.push(marca);
          }
          console.log(marcasProveedor);
          this.setState({ marcasProveedor: marcasProveedor });
        }.bind(this)
      )
      .catch(function (error) {});
  }
  // ------------------------------------------------------------------------------------------------------
  // ItemCotizacion
  // ------------------------------------------------------------------------------------------------------
  handleCloseInsertarProducto() {
    this.setState({ mostrarDialogoInsertarProducto: false });
    this.setState({
      mostrarCantidadInsertarProducto: "",
    });
  }
  handleCloseInsertarItemCotizacion(event) {
    this.setState({ mostrarInsertarItemCotizacion: false });
  }
  handleCloseEditarItemCotizacionPiso() {
    this.setState({ mostrarEditarItemCotizacionPiso: false });
  }
  handleCloseEditarItemCotizacion(event) {
    this.setState({ mostrarEditarItemCotizacion: false });
  }
  handleCloseEditarItemOfertado(event) {
    this.setState({ mostrarEditarItemCotizacionOfertado: false });
  }
  handleCloseEditarItemCotizacionAbierto(event) {
    this.setState({ mostrarEditarItemCotizacionAbierto: false });
  }
  handleCloseEliminarItemCotizacion(event) {
    this.setState({ mostrarEliminarItemCotizacion: false });
  }
  handleCloseDescuentoTodosProductos(event) {
    this.setState({ mostrarDescuentoTodosProductos: false });
  }
  handleCloseIVATodosProductos(event) {
    this.setState({ mostrarIVATodosProductos: false });
  }
  handleCloseModificarCantidad(event) {
    this.setState({ mostrarActualizarModificarCantidad: false });
  }
  handleCloseCerrarCotizacion() {
    this.setState({ mensajeRespuestaEnviarCotizacion: "" });
    this.setState({ mostrarCerrarCotizacion: false });
  }
  handleCloseEnviarCotizacion() {
    this.setState({ mensajeRespuestaEnviarCotizacion: "" });
    this.setState({ mostrarEnviarCotizacion: false });
  }

  // ----------------------------------------
  // Descuento todos productos
  // ----------------------------------------
  descuentoTodosProductosModificar(event) {
    var descuentoTodosProductos = event.target.value;
    this.setState({ descuentoTodosProductos: descuentoTodosProductos });
  }
  ivaTodosProductosModificar(event) {
    var ivaTodosProductosModificar = event.target.value;
    this.setState({ ivaTodosProductosModificar: ivaTodosProductosModificar });
  }
  handleShowModificarIVATodosProductos() {
    this.setState({ mostrarIVATodosProductos: true });
  }
  handleShowCerrarCotizacion() {
    this.setState({ mostrarCerrarCotizacion: true });
  }
  handleShowEnviarCotizacion() {
    this.setState({ mostrarEnviarCotizacion: true });
  }
  handleShowModificarDescuentoTodosProductos() {
    this.setState({ mostrarDescuentoTodosProductos: true });
  }

  formularioModificarIVATodosProductos(event) {
    event.preventDefault();
    this.modificarIVATodosProductos();
  }
  modificarIVATodosProductos() {
    var codigo = localStorage.getItem("simuladores.proveedores.codigoUsuario");
    var idCotizacion = this.state.idCotizacion;
    var iva = this.state.ivaTodosProductosModificar;

    var info = { codigo: codigo, idCotizacion: idCotizacion, iva: iva };
    this.setState({ respuestaActualizacionMasiva: "Actualizando" });
    axios
      .post(
        misConstantes.URL_CONSULTA +
          "/ServletModificarIVATodosProductosCotizacion",
        info,
        { params: info }
      )
      .then(
        function (response) {
          var respuesta = response.data;
          var mensaje = respuesta.mensaje;
          this.setState({ respuestaActualizacionMasiva: mensaje });
          if (respuesta.respuesta == "exito") {
            setTimeout(
              function () {
                this.setState({
                  mostrarIVATodosProductos: false,
                  respuestaActualizacionMasiva: "",
                });
              }.bind(this),
              1000
            );
            this.cargarCotizacion();
            //				this.cargarItemCotizacions();
          }
        }.bind(this)
      )
      .catch(function (error) {});
  }
  formularioModificarDescuentoTodosProductos(event) {
    event.preventDefault();
    this.modificarDescuentoTodosProductos();
  }
  modificarDescuentoTodosProductos() {
    var codigo = localStorage.getItem("simuladores.proveedores.codigoUsuario");
    var idCotizacion = this.state.idCotizacion;
    var descuento = this.state.descuentoTodosProductos;

    var info = {
      codigo: codigo,
      idCotizacion: idCotizacion,
      descuento: descuento,
    };
    this.setState({ respuestaActualizacionMasiva: "Actualizando" });
    axios
      .post(
        misConstantes.URL_CONSULTA +
          "/ServletModificarDescuentoTodosProductosCotizacion",
        info,
        { params: info }
      )
      .then(
        function (response) {
          var respuesta = response.data;
          var mensaje = respuesta.mensaje;
          this.setState({ respuestaActualizacionMasiva: mensaje });
          if (respuesta.respuesta == "exito") {
            setTimeout(
              function () {
                this.setState({
                  mostrarDescuentoTodosProductos: false,
                  respuestaActualizacionMasiva: "",
                });
              }.bind(this),
              1000
            );
            this.cargarCotizacion();
            //				this.cargarItemCotizacions();
          }
        }.bind(this)
      )
      .catch(function (error) {});
  }

  modificarItemOfertado(event, idItemModificacion) {
    event.preventDefault();
    this.setState({
      mostrarEditarItemCotizacionOfertado: true,
      idItemCotizacionEdicionOfertado: idItemModificacion,
    });

    var codigo = localStorage.getItem("simuladores.proveedores.codigoUsuario");
    var idCotizacion = this.state.idCotizacion;
    var productosAbiertos = [];
    var idSimulacion = this.state.idSimulacion;
    var info = {
      codigo: codigo,
      idCotizacion: idCotizacion,
      id: idSimulacion,
    };
    this.setState({ respuestaActualizacionMasiva: "Actualizando" });

    axios
      .post(misConstantes.URL_CONSULTA + "/ServletProductosProveedor", info, {
        params: info,
      })
      .then(
        function (response) {
          var productos = response.data;
          console.log(productos);
          console.log(productos.length);
          for (var i = 0; i < productos.length; i++) {
            console.log(productos[i]);
            var producto = productos[i];
            var productoRes = {
              value: {
                value: producto.id,
                label: producto.referencia + ". " + producto.descripcion,
              },
              label: producto.referencia + ". " + producto.descripcion,
            };
            productosAbiertos.push(productoRes);
          }
          console.log(productosAbiertos);
          this.setState({
            productosAbiertos: productosAbiertos,
          });
        }.bind(this)
      )
      .catch(function (error) {});
  }

  modificarItemAbierto(event, idItemModificacion) {
    event.preventDefault();
    this.setState({
      mostrarEditarItemCotizacionAbierto: true,
      idItemCotizacionEdicionAbierto: idItemModificacion,
    });

    var codigo = localStorage.getItem("simuladores.proveedores.codigoUsuario");
    var idCotizacion = this.state.idCotizacion;

    var info = {
      codigo: codigo,
      idCotizacion: idCotizacion,
      id: idItemModificacion,
    };
    this.setState({ respuestaActualizacionMasiva: "Actualizando" });
    axios
      .post(misConstantes.URL_CONSULTA + "/ServletItemCotizacion", info, {
        params: info,
      })
      .then(
        function (response) {
          var itemCotizacion = response.data;

          var valorCatalogo = itemCotizacion.valorCatalogo;

          document.getElementById("ivaModificarItemAbierto").value =
            itemCotizacion.totalImpuestosPositivos;
          document.getElementById("precioUnitarioModificarItemAbierto").value =
            itemCotizacion.precioUnitarioAntesImpuestos;

          var mostrarDescuentoValorActualizarItem = "";
          var mostrarValorCatalogoActualizarItem = "none";
          if (itemCotizacion.calculoFormula + "" == "true") {
            mostrarDescuentoValorActualizarItem = "none";
            mostrarValorCatalogoActualizarItem = "";
          }
          this.setState({
            mostrarDescuentoValorActualizarItem:
              mostrarDescuentoValorActualizarItem,
            mostrarValorCatalogoActualizarItem:
              mostrarValorCatalogoActualizarItem,
            valorCatalogo: valorCatalogo,
          });
          //
        }.bind(this)
      )
      .catch(function (error) {});
  }
  modificarItemPiso(event, idItemModificacion) {
    //		alert("222222");
    event.preventDefault();
    this.setState({
      mostrarEditarItemCotizacionPiso: true,
      idItemCotizacionEdicionPiso: idItemModificacion,
    });

    var codigo = localStorage.getItem("simuladores.proveedores.codigoUsuario");
    var idCotizacion = this.state.idCotizacion;

    var info = {
      codigo: codigo,
      idCotizacion: idCotizacion,
      id: idItemModificacion,
    };
    this.setState({ respuestaActualizacionMasiva: "Actualizando" });
    axios
      .post(misConstantes.URL_CONSULTA + "/ServletItemCotizacion", info, {
        params: info,
      })
      .then(
        function (response) {
          var itemCotizacion = response.data;
          document.getElementById("cantidadModificarItemPiso").value =
            itemCotizacion.precioUnitarioAntesImpuestos;
        }.bind(this)
      )
      .catch(function (error) {});
  }

  // ----------------------------------------
  // Insertar producto
  // ----------------------------------------
  insertarProductoProveedorProducto() {
    var codigo = localStorage.getItem("simuladores.proveedores.codigoUsuario");
    var idCotizacion = this.state.idCotizacion;
    var productoInsertar = this.state.productoInsertar;

    //		alert( JSON.stringify( productoInsertar ) );
    //		alert( idCotizacion );

    var iva = document.getElementById("ivaInsertarProducto").value;
    var descuento = document.getElementById("descuentoInsertarProducto").value;
    var cantidad = document.getElementById("cantidadInsertarProducto").value;
    var idProducto = productoInsertar.value;

    this.setState({ mensajeInsertarProducto: "Insertando" });

    var info = {
      codigo: codigo,
      idCotizacion: idCotizacion,
      iva: iva,
      descuento: descuento == "" ? 0 : descuento,
      cantidad: cantidad,
      idProducto: idProducto,
    };

    axios
      .post(
        misConstantes.URL_CONSULTA + "/ServletInsertarProductoCotizacion",
        info,
        { params: info }
      )
      .then(
        function (response) {
          var respuesta = response.data;
          //			alert( JSON.stringify(respuesta) );

          this.setState({ mensajeInsertarProducto: respuesta.mensaje });
          if (respuesta.respuesta == "exito") {
            document.getElementById("ivaInsertarProducto").value = "";
            document.getElementById("descuentoInsertarProducto").value = "";
            document.getElementById("cantidadInsertarProducto").value = "";

            this.setState({
              mensajeInsertarProducto: "",
              mostrarDialogoInsertarProducto: false,
            });
            this.cargarCotizacion();
          }

          //
        }.bind(this)
      )
      .catch(function (error) {});
  }
  cargarProductos() {
    var codigo = localStorage.getItem("simuladores.proveedores.codigoUsuario");
    var idCotizacion = this.state.idCotizacion;
    var info = { codigo: codigo, idCotizacion: idCotizacion };
    var productosTemp = [];

    axios
      .post(misConstantes.URL_CONSULTA + "/ServletProductosCotizacion", info, {
        params: info,
      })
      .then(
        function (response) {
          var productos = response.data;
          productosTemp = productos;
          //			alert( JSON.stringify(productos) );
          var productosProveedor = [];
          for (var i = 0; i < productos.length; i++) {
            var producto = productos[i].producto;
            var productoPrecio = {
              value: {
                value: productos[i].id,
                label: producto.referencia + ". " + producto.descripcion,
              },
              label: producto.referencia + ". " + producto.descripcion,
            };
            productosProveedor.push(productoPrecio);
          }
          this.setState({
            productosProveedor: productosProveedor,
            productos: productosTemp,
          });
        }.bind(this)
      )
      .catch(function (error) {});
  }

  modificarProductoInsertarProducto(event) {
    var productoInsertar = event.value;
    var productoSeleccionado = null;
    var idProducto = productoInsertar.value;
    for (var i = 0; i < this.state.productos.length; i++) {
      var productoTemp = this.state.productos[i];
      if (productoTemp.id == idProducto) {
        productoSeleccionado = productoTemp;
      }
    }

    if (productoSeleccionado != null) {
      var calculaCantidadCotizacion =
        productoSeleccionado.producto.calculaCantidadCotizacion;

      var mostrarCantidadInsertarProducto = "";
      if (calculaCantidadCotizacion == true) {
        mostrarCantidadInsertarProducto = "none";
        document.getElementById("cantidadInsertarProducto").value = 0;
      }
      this.setState({
        mostrarCantidadInsertarProducto: mostrarCantidadInsertarProducto,
      });
    }

    this.setState({ productoInsertar: productoInsertar });
  }
  modificarItemOfertar(event) {
    var itemOfertar = event.value;
    console.log(itemOfertar);
    this.setState({ itemOfertar: itemOfertar });
  }
  handleAbrirInsertarProducto(event) {
    event.preventDefault();
    this.setState({ mostrarDialogoInsertarProducto: true });
  }
  // ----------------------------------------
  // Cargar ItemCotizacion
  // ----------------------------------------
  cargarCotizacion() {
    var codigo = localStorage.getItem("simuladores.proveedores.codigoUsuario");
    var idCotizacion = this.state.idCotizacion;
    var info = { codigo: codigo, id: idCotizacion };

    axios
      .post(misConstantes.URL_CONSULTA + "/ServletCotizacion", info, {
        params: info,
      })
      .then(
        function (response) {
          var cotizacion = response.data;
          var entidad = cotizacion.entidad;
          var simulador = cotizacion.simulador;
          var eventoCotizacion = cotizacion.eventoCotizacion;
          var simulacion = cotizacion.simulacion;
          var idSimulacion = simulacion.id;
          var tipoCotizacion = cotizacion.tipo;
          var catalogo = cotizacion.catalogo;
          var esAdjudicacionMultiple = simulador.adjudicacionMultiple;

          var mostrarBotones = "initial";
          var nombreCatalogo = catalogo.nombre;

          var nombreContacto = simulacion.nombreContacto;
          var correoContacto = simulacion.correoContacto;
          var telefonoContacto = simulacion.telefonoContacto;

          if (cotizacion.estadoCierre == 2 || cotizacion.estadoCierre == 3) {
            mostrarBotones = "none";
          }

          var mostrarErroresEventoCotizacion = "none";
          if (
            cotizacion.estadoCierreEventoCotizacion == 3 ||
            cotizacion.estado == 2
          ) {
            mostrarErroresEventoCotizacion = "";
          }
          var mensajesErroresEventoCotizacion = "";
          if (simulacion.estado == 3) {
            mensajesErroresEventoCotizacion =
              "El proceso nuevamente está solicitando cotizaciones, por favor ir al enlace cotizaciones y buscar por el consecutivo " +
              simulacion.consecutivo;
          }
          var mostrarTotales = "";
          if (simulacion.tipoSimulador == 3 || simulacion.tipoSimulador == 4) {
            mostrarTotales = "none";
          }

          var nombreTipoSimulador = simulador.nombreTipo;
          //			alert( JSON.stringify(simulador) );
          //			alert( simulador.solicitaMarca );
          var mostrarSolicitarMarca = simulador.solicitaMarca;
          this.setState({
            nombreTipoSimulador: nombreTipoSimulador,
            nombreContacto: nombreContacto,
            correoContacto: correoContacto,
            telefonoContacto: telefonoContacto,
            mostrarSolicitarMarca: mostrarSolicitarMarca,
            nombreCatalogo: nombreCatalogo,
            mostrarErroresEventoCotizacion: mostrarErroresEventoCotizacion,
            mensajesErroresEventoCotizacion: mensajesErroresEventoCotizacion,
            esAdjudicacionMultiple: esAdjudicacionMultiple,
          });

          var fechaRespuesta = eventoCotizacion.sfechaRespuesta;

          var consecutivoCotizacion = cotizacion.consecutivo;
          var nombreSimulador = simulador.nombre;
          var nombreEntidad = entidad.nombre;
          var consecutivoEventoCotizacion = eventoCotizacion.consecutivo;
          var consecutivoProcesoSimulacion = simulacion.consecutivo;

          var mostrarDatosminimoPrecio = "";
          var mostrarDatosMontoAgotable = "none";
          var presupuesto = "";
          var cantidadOferta = "";

          //			alert( JSON.stringify( cotizacion ) );

          if (cotizacion.tipo == 2) {
            mostrarDatosMontoAgotable = "";
            mostrarDatosminimoPrecio = "none";
            presupuesto = cotizacion.spresupuesto;
            cantidadOferta = cotizacion.scantidadOfertada;
          }

          //			alert(  simulador.proveedorIngresaItems  );
          //			alert(  JSON.stringify(  simulador  )  );

          var mostrarInsertarProducto = "none";
          if (simulador.proveedorIngresaItems + "" == "true") {
            mostrarInsertarProducto = "";
          }

          var mostrarErrores = "none";
          var mensajeErrores = "";
          var cotizacionValida = cotizacion.valida;
          if (cotizacionValida + "" == "false") {
            mostrarErrores = "";
            mensajeErrores = "Hay productos que no tienen precio";
          }
          var puedeVerCotizaciones = "none";
          if (cotizacion.estadoCierreEventoCotizacion === 2) {
            if (
              simulacion.estadoProceso === 5 ||
              simulacion.estadoProceso === 6 ||
              simulacion.estadoProceso === 7
            )
              puedeVerCotizaciones = "";
          }
          console.log(puedeVerCotizaciones);
          //			var estadoEnvio = "";
          var mostrarPresentarseLinea = "none";
          if (simulador.obligatorioTodasLineas == false) {
            var mostrarPresentarseLinea = "";
          }

          var visualizacionOfertada = "none";
          if (simulador.tipo == 4) {
            visualizacionOfertada = "";
          }

          this.setState({
            entidad: entidad,
            simulador: simulador,
            cotizacion: cotizacion,
            mostrarBotones: mostrarBotones,
            simulacion: simulacion,
            idSimulacion: idSimulacion,
            eventoCotizacion: eventoCotizacion,
            fechaRespuesta: fechaRespuesta,
            consecutivoCotizacion: consecutivoCotizacion,
            nombreSimulador: nombreSimulador,
            nombreEntidad: nombreEntidad,
            consecutivoEventoCotizacion: consecutivoEventoCotizacion,
            consecutivoProcesoSimulacion: consecutivoProcesoSimulacion,
            mostrarDatosMontoAgotable: mostrarDatosMontoAgotable,
            presupuesto: presupuesto,
            cantidadOferta: cantidadOferta,
            mostrarDatosminimoPrecio: mostrarDatosminimoPrecio,
            tipoCotizacion: tipoCotizacion,
            mostrarInsertarProducto: mostrarInsertarProducto,
            ivaCantidad: cotizacion.stotalIVACantidad,
            valorAntesIVACantidad: cotizacion.stotalAntesIVACantidad,
            descuentoCantidad: cotizacion.sdescuentoCantidad,
            cotizacionValida: cotizacionValida,
            mostrarErrores: mostrarErrores,
            mensajeErrores: mensajeErrores,
            spresupuesto: presupuesto,
            puedeVerCotizaciones: puedeVerCotizaciones,
            mostrarTotales: mostrarTotales,
            mostrarPresentarseLinea: mostrarPresentarseLinea,
            visualizacionOfertada: visualizacionOfertada,
          });

          var datosExtras = [];
          var datos = simulacion.jdatos;
          for (var i = 0; i < datos.length; i++) {
            var caracteristica = datos[i].caracteristica;
            var valor = datos[i].valor;
            var datoExtra = (
              <>
                <tr>
                  <td>{caracteristica.nombre}</td>
                  <td>{valor}</td>
                </tr>
              </>
            );
            datosExtras.push(datoExtra);
          }

          this.setState({ datosExtras: datosExtras });

          this.cargarItemCotizacions();
          this.cuentaRegresiva();
          this.cargarArchivoProveedorProcesoSimulacions();
          this.cargarArchivoEntidadProcesoSimulacions();
          this.cargarSimulacionGravamens();
          this.cargarCotizaciones();
        }.bind(this)
      )
      .catch(function (error) {});
  }
  cargarItemCotizacions() {
    var codigo = localStorage.getItem("simuladores.proveedores.codigoUsuario");

    var idCotizacion = this.state.idCotizacion;
    var info = { codigo: codigo, idCotizacion: idCotizacion };
    this.setState({
      cargandoItemsCotizacion: "Cargando, esto puede tardar unos segundos",
    });

    axios
      .post(misConstantes.URL_CONSULTA + "/ServletItemCotizacionsJSON", info, {
        params: info,
      })
      .then(
        function (response) {
          var datosFinales = response.data;
          //			alert( JSON.stringify(  datosFinales ) );

          var sfechaRespuesta = this.state.fechaRespuesta;

          var dfechaRespuesta = this.stringToFecha(sfechaRespuesta);
          var tfechaRespuesta = dfechaRespuesta.getTime();
          var ahora = new Date().getTime();

          var distance = tfechaRespuesta - ahora;

          //			alert( distance );
          //			alert( this.state.cotizacion.estadoCierre );

          //			var cotizacion = this.state.cotizacion;
          var columns = this.state.columnas;
          if (
            this.state.cotizacion.estadoCierre == 2 ||
            this.state.cotizacion.estadoCierre == 3 ||
            distance < 0
          ) {
            //				alert( "111222" );
            var columns = this.state.columnasCerrado;
          }
          var rows = [];

          for (var i = 0; i < datosFinales.length; i++) {
            //				alert( datosFinales[i].mostrar );
            if (datosFinales[i].mostrar + "" == "true") {
              var marca = "";
              if (datosFinales[i].marca != null) {
                marca =
                  "<br/><b>Marca:</b> " +
                  datosFinales[i].marca +
                  " - <b>Referencia:</b> " +
                  datosFinales[i].especificacionEquipo +
                  "<br/>";
              }

              const identificador = datosFinales[i].id + "";
              var nombre = datosFinales[i].texto;
              if (nombre != datosFinales[i].referencia) {
                nombre = datosFinales[i].referencia + ". " + nombre + marca;
              }

              var data = [];
              //					alert(  datosFinales[i].datosExtra );
              if (datosFinales[i].datosExtra != null) {
                data = datosFinales[i].datosExtra;
              }

              for (var j = 0; j < data.length - 1; j++) {
                var valor = data[j].label;
                if (valor == null) {
                  valor =
                    "<span style = 'font-style: italic; font-size: 10px;'> " +
                    data[j].value +
                    "</span>";
                }
                if (valor != null) {
                  nombre +=
                    "<span style = 'font-style: italic; font-size: 10px;'> - " +
                    valor +
                    "</span>";
                }
              }

              var sprecioSimulacion = "";
              var ssubtotalPrecioSimulacion = "";
              if (datosFinales[i].sprecioSimulacion != -1) {
                sprecioSimulacion = datosFinales[i].sprecioSimulacion;
                ssubtotalPrecioSimulacion = (
                  <>
                    Sub: {datosFinales[i].ssubtotalPrecioSimulacion}
                    <br />
                    Cat: {datosFinales[i].sprecioCatalogo}
                  </>
                );
                if (datosFinales[i].calculoFormula == true) {
                  ssubtotalPrecioSimulacion = (
                    <>Uni-Final: {datosFinales[i].svalorCatalogo}</>
                  );
                }
              }
              var valoresSimulacion = (
                <>
                  Uni: {sprecioSimulacion} <br />
                  {ssubtotalPrecioSimulacion}
                </>
              );
              var iva = (
                <>
                  {" "}
                  %: {datosFinales[i].stotalImpuestosPositivos}
                  <br />
                  {datosFinales[i].svalorImpuestosPositivos}{" "}
                </>
              );

              var descuento = (
                <>
                  {" "}
                  %: {datosFinales[i].sdescuentoPorcentaje}
                  <br />
                  {datosFinales[i].descuentoValorUnitario === 0
                    ? "0.00"
                    : datosFinales[i].descuentoValorUnitario < 0
                    ? datosFinales[i].sdescuentoValor.substring(1)
                    : // : datosFinales[i].sdescuentoValor //asi estaba antes
                      datosFinales[i].stotalDescuentoAdjudicado}{" "}
                </>
              );

              var botones = <></>;
              var botonSolicitarMarca = <></>;
              if (this.state.mostrarSolicitarMarca + "" == "true") {
                botonSolicitarMarca = (
                  <>
                    <a
                      href=""
                      onClick={(event) =>
                        this.handleAbrirCargaMarca(event, identificador + "")
                      }
                    >
                      <i class="fas fa-tag"></i>
                    </a>
                    &nbsp;{" "}
                  </>
                );
              }

              if (datosFinales[i].modificaProveedor + "" == "true") {
                if (datosFinales[i].tipoValidacion == 5) {
                  botones = (
                    <>
                      <a
                        href=""
                        onClick={(event) =>
                          this.modificarItemOfertado(event, identificador + "")
                        }
                      >
                        <i class="fas fa-edit"></i>
                      </a>
                      &nbsp;
                      {botonSolicitarMarca}
                    </>
                  );
                } else if (datosFinales[i].tipoValidacion == 3) {
                  botones = (
                    <>
                      <a
                        href=""
                        onClick={(event) =>
                          this.modificarItemAbierto(event, identificador + "")
                        }
                      >
                        <i class="fas fa-edit"></i>
                      </a>
                      &nbsp;
                      {botonSolicitarMarca}
                    </>
                  );
                } else if (
                  datosFinales[i].tipoValidacion == 2 ||
                  datosFinales[i].tipoValidacion == 3
                ) {
                  botones = (
                    <>
                      <a
                        href=""
                        onClick={(event) =>
                          this.modificarItemPiso(event, identificador + "")
                        }
                      >
                        <i class="fas fa-edit"></i>
                      </a>
                      &nbsp;
                      {botonSolicitarMarca}
                    </>
                  );
                } else {
                  botones = (
                    <>
                      <a
                        href=""
                        onClick={(event) =>
                          this.handleShowEditarItemCotizacion(
                            event,
                            identificador + ""
                          )
                        }
                      >
                        <i class="fas fa-edit"></i>
                      </a>
                      &nbsp;
                      {botonSolicitarMarca}
                    </>
                  );
                }

                if (datosFinales[i].borrar == true) {
                  botones = (
                    <>
                      {botones}{" "}
                      <a
                        href=""
                        onClick={(event) =>
                          this.handleShowEliminarItemCotizacion(
                            event,
                            identificador + "",
                            nombre
                          )
                        }
                        style={{ color: "red" }}
                      >
                        <i class="fas fa-trash"></i>
                      </a>
                    </>
                  );
                }
                botones = (
                  <>
                    <div style={{ width: "100%", textAlign: "center" }}>
                      {botones}
                    </div>
                  </>
                );
              }

              var subtotal =
                datosFinales[i].subtotal < 0
                  ? datosFinales[i].ssubtotal.substring(1)
                  : datosFinales[i].ssubtotal;
              if (datosFinales[i].presentoLinea == false) {
                subtotal = "No presenta";
              }
              var cantidad = <>{datosFinales[i].cantidad}</>;
              // alert( JSON.stringify(this.state.cotizacion) );
              // alert( JSON.stringify(this.state.simulador) );
              if (this.state.simulador.tipo == 4) {
                cantidad = (
                  <>
                    Solicitada: {datosFinales[i].cantidad}
                    <br />
                    Ofertada: {datosFinales[i].cantidadOfertada}
                  </>
                );
              }

              var row = {
                texto: ReactHtmlParser(nombre),
                precioSimulacion: <>{valoresSimulacion}</>,
                precioUnitarioAntesImpuestos: (
                  <>
                    {datosFinales[i].precioUnitarioAntesImpuestos < 0
                      ? datosFinales[i].sprecioUnitarioAntesImpuestos.substring(
                          1
                        )
                      : datosFinales[i].sprecioUnitarioAntesImpuestos}
                    <br />
                    Cat:{" "}
                    {datosFinales[i].precioUnitarioAntesImpuestos < 0
                      ? datosFinales[i].sprecioUnitarioAntesImpuestos.substring(
                          1
                        )
                      : datosFinales[i].sprecioCatalogo}
                  </>
                ),
                cantidad: cantidad,
                totalImpuestosPositivos: iva,
                descuento: descuento,
                subtotal: subtotal,

                botones: botones,
              };

              if (datosFinales[i].sprecioUnitarioAntesImpuestos + "" == "-1") {
                var row = {
                  texto: <>{nombre}</>,
                  precioSimulacion: "NA",
                  precioUnitarioAntesImpuestos: "NA",
                  cantidad: datosFinales[i].cantidad,
                  totalImpuestosPositivos: "NA",
                  descuento: "NA",
                  subtotal: "NA",

                  botones: botones,
                };
              }

              rows.push(row);

              var subproductos = datosFinales[i].subproductos;
              for (var l = 0; l < subproductos.length; l++) {
                const nombreSubproducto = subproductos[l].nombre;
                const idItemCotizacionSubproducto = datosFinales[i].id;
                const idSubproducto = subproductos[l].id;

                const valor = subproductos[l].valor;
                const iva = subproductos[l].iva;

                var stotal = subproductos[l].stotal;
                if (datosFinales[i].presentoLinea == false) {
                  stotal = "No presenta";
                }

                var botonesSubproductos = (
                  <>
                    <div style={{ width: "100%", textAlign: "center" }}>
                      <a
                        href=""
                        onClick={(event) =>
                          this.handleAbrirNombreSubproducto(
                            event,
                            nombreSubproducto,
                            idItemCotizacionSubproducto,
                            idSubproducto,
                            iva,
                            valor
                          )
                        }
                      >
                        <i class="fas fa-edit"></i>
                      </a>
                    </div>
                  </>
                );
                var row = {
                  texto: (
                    <>
                      <ul>
                        <li>
                          {subproductos[l].nombre} - {datosFinales[i].texto}
                        </li>
                      </ul>
                    </>
                  ),
                  precioSimulacion: subproductos[l].svalor,
                  precioUnitarioAntesImpuestos: (
                    <>
                      {subproductos[l].stotalUnitarioAntesImpuestos}
                      <br />
                      Val: {subproductos[l].valor}
                    </>
                  ),
                  cantidad: datosFinales[i].cantidadOfertada,
                  totalImpuestosPositivos: "NA",
                  descuento: "NA",
                  subtotal: stotal,

                  botones: botonesSubproductos,
                };
                rows.push(row);
              }
            }
          }

          var datos = { columns: columns, rows: rows };
          this.setState({ datos: datos });

          this.setState({ cargandoItemsCotizacion: "" });
        }.bind(this)
      )
      .catch(function (error) {
        alert(error);
        alert("Error cargando los items de la cotización");
      });
  }
  // ----------------------------------------
  // Modificar cantidad ofertada
  // ----------------------------------------
  handleModificarCantidadOfertada(event) {
    event.preventDefault();
    this.setState({ mostrarActualizarModificarCantidad: true });
    setTimeout(
      function () {
        document.getElementById(
          "cantidadOfertada_modificarCantidadOfertad"
        ).value = this.state.cantidadOferta;
      }.bind(this),
      1000
    );
  }
  modificarCantidadOfertada(event) {
    event.preventDefault();

    var codigo = localStorage.getItem("simuladores.proveedores.codigoUsuario");
    var idCotizacion = this.state.idCotizacion;
    var cantidadOfertada = document.getElementById(
      "cantidadOfertada_modificarCantidadOfertad"
    ).value;

    this.setState({ mensajeActualizarCantidadOfertada: "Modificando" });
    var info = {
      codigo: codigo,
      idCotizacion: idCotizacion,
      cantidadOfertada: cantidadOfertada,
    };

    axios
      .post(
        misConstantes.URL_CONSULTA + "/ServletActualizarCantidadOfertada",
        info,
        { params: info }
      )
      .then(
        function (response) {
          var respuesta = response.data;
          //			alert( JSON.stringify( respuesta ) );
          this.setState({
            mensajeActualizarCantidadOfertada: respuesta.mensaje,
          });
          if (respuesta.respuesta == "exito") {
            this.setState({
              cantidadOferta: cantidadOfertada,
              mostrarActualizarModificarCantidad: false,
              mensajeActualizarCantidadOfertada: "",
            });
          }
        }.bind(this)
      )
      .catch(function (error) {});
  }
  // ----------------------------------------
  // Editar ItemCotizacion
  // ----------------------------------------
  handleShowEditarItemCotizacion(event, id) {
    event.preventDefault();
    var codigo = localStorage.getItem("simuladores.proveedores.codigoUsuario");
    var idCotizacion = this.state.idCotizacion;
    this.setState({
      mostrarEditarItemCotizacion: true,
      idItemCotizacionEditar: id,
      respuestaEditarItemCotizacion: "Cargando",
      requiereEdicionProveedor: false,
    });
    var info = { codigo: codigo, idCotizacion: idCotizacion, id: id };
    axios
      .post(misConstantes.URL_CONSULTA + "/ServletItemCotizacion", info, {
        params: info,
      })
      .then(
        function (response) {
          var itemCotizacion = response.data;

          var cantidadOfertada = itemCotizacion.cantidadOfertada;
          var valorCatalogo = itemCotizacion.valorCatalogo;
          const ivaEditar = itemCotizacion.totalImpuestosPositivos;
          const precioUnitarioAntesImpuestos =
            itemCotizacion.precioFinalUnitario;
          const descuentoPorcentaje = itemCotizacion.descuentoPorcentaje;
          const precioUnitarioSimulacion = itemCotizacion.precioSimulacion;
          const textoItem =
            (itemCotizacion.texto || "") + " " + (itemCotizacion.referencia || "");
          const esLogistica =
            textoItem.toLowerCase().indexOf("logistica") >= 0 ||
            textoItem.toLowerCase().indexOf("logística") >= 0;
          const requiereEdicionProveedor =
            itemCotizacion.requiereEdicionProveedor + "" == "true" ||
            esLogistica;

          const valorIVAEditar =
            (precioUnitarioAntesImpuestos * ivaEditar) / 100;
          var mostrarDescuento = "initial";
          if (itemCotizacion.valorCatalogo == -1) {
            mostrarDescuento = "none";
          }
          if (requiereEdicionProveedor) {
            mostrarDescuento = "none";
          }
          var valorPresentoLinea = "1";
          if (itemCotizacion.presentoLinea == false) {
            var valorPresentoLinea = "0";
          }
          document.getElementById("presentoLinea").value = valorPresentoLinea;

          this.setState({
            mostrarDescuento: mostrarDescuento,
            ivaEditar: ivaEditar,
            valorIVAEditar: valorIVAEditar,
            precioUnitarioAntesImpuestos: precioUnitarioAntesImpuestos,
            descuentoPorcentaje: descuentoPorcentaje,
            idEditarItemCotizacion: id,
            precioUnitarioSimulacion: precioUnitarioSimulacion,
            requiereEdicionProveedor: requiereEdicionProveedor,
            respuestaEditarItemCotizacion: "",
            cantidadOfertada: cantidadOfertada,
          });

          var mostrarDescuentoValorActualizarItem = "";
          var mostrarValorCatalogoActualizarItem = "none";
          if (itemCotizacion.calculoFormula + "" == "true") {
            mostrarDescuentoValorActualizarItem = "none";
            mostrarValorCatalogoActualizarItem = "";
          }
          this.setState({
            mostrarDescuentoValorActualizarItem:
              mostrarDescuentoValorActualizarItem,
            mostrarValorCatalogoActualizarItem:
              mostrarValorCatalogoActualizarItem,
            valorCatalogo: valorCatalogo,
          });
        }.bind(this)
      )
      .catch(function (error) {});
  }

  //	{actualizarIVAEditar - ivaEditar    precioUnitarioAntesImpuestos - actualizarPrecioUnitarioAntesImpuestosEditar     descuentoPorcentaje -  descuentoPorcentajeEditar  }
  actualizarIVAEditar(event) {
    var ivaEditar = event.target.value;
    var precioUnitarioAntesImpuestos = this.state.precioUnitarioAntesImpuestos;
    var valorIVAEditar = (ivaEditar * precioUnitarioAntesImpuestos) / 100;

    this.setState({ ivaEditar: ivaEditar, valorIVAEditar: valorIVAEditar });
  }
  actualizarValorCatalogo(event) {
    var valorCatalogo = event.target.value;
    this.setState({ valorCatalogo: valorCatalogo });
  }
  actualizarIVAValorCatalogo(event) {
    var IVAvalorCatalogo = event.target.value;
    this.setState({ IVAvalorCatalogo: IVAvalorCatalogo });
  }
  actualizarCantidadOfertada(event) {
    var cantidadOfertada = event.target.value;
    this.setState({ cantidadOfertada: cantidadOfertada });
  }
  actualizarValorIVAEditar(event) {
    var valorIVAEditar = event.target.value;
    var precioUnitarioAntesImpuestos = this.state.precioUnitarioAntesImpuestos;

    var ivaEditar = (valorIVAEditar * 100) / precioUnitarioAntesImpuestos;
    this.setState({ ivaEditar: ivaEditar, valorIVAEditar: valorIVAEditar });
  }
  actualizarPrecioUnitarioAntesImpuestosEditar(event) {
    var precioUnitarioAntesImpuestos = event.target.value;
    var precioUnitarioSimulacion = this.state.precioUnitarioSimulacion;
    var descuentoPorcentaje = 0;
    if (
      this.state.precioUnitarioSimulacion < 0 ||
      (precioUnitarioSimulacion == 0 && this.state.requiereEdicionProveedor)
    ) {
      this.setState({
        precioUnitarioAntesImpuestos: precioUnitarioAntesImpuestos,
        descuentoPorcentaje: descuentoPorcentaje,
      });
    } else {
      var descuentoPorcentaje =
        ((precioUnitarioSimulacion - precioUnitarioAntesImpuestos) /
          precioUnitarioSimulacion) *
        100;
      this.setState({
        precioUnitarioAntesImpuestos: precioUnitarioAntesImpuestos,
        descuentoPorcentaje: descuentoPorcentaje,
      });
    }

    var ivaEditar = this.state.ivaEditar;
    var valorIVAEditar = (ivaEditar * precioUnitarioAntesImpuestos) / 100;

    this.setState({ ivaEditar: ivaEditar, valorIVAEditar: valorIVAEditar });
  }
  descuentoPorcentajeEditar(event) {
    var descuentoPorcentaje = event.target.value;
    var precioUnitarioSimulacion = this.state.precioUnitarioSimulacion;
    var precioUnitarioAntesImpuestos = this.state.precioUnitarioAntesImpuestos;
    if (!(precioUnitarioSimulacion == 0 && this.state.requiereEdicionProveedor)) {
      precioUnitarioAntesImpuestos =
        (precioUnitarioSimulacion * (100 - descuentoPorcentaje)) / 100;
    }

    this.setState({
      precioUnitarioAntesImpuestos: precioUnitarioAntesImpuestos,
      descuentoPorcentaje: descuentoPorcentaje,
    });

    var ivaEditar = this.state.ivaEditar;
    var valorIVAEditar = (ivaEditar * precioUnitarioAntesImpuestos) / 100;

    this.setState({ ivaEditar: ivaEditar, valorIVAEditar: valorIVAEditar });
  }
  formularioEditarItemCotizacion(event) {
    event.preventDefault();
    this.editarItemCotizacion(event);
  }

  editarItemCotizacionOfertado(event) {
    this.setState({ mensajeModificarValoresOfertado: "Editando" });

    var codigo = localStorage.getItem("simuladores.proveedores.codigoUsuario");
    var idCotizacion = this.state.idCotizacion;
    var precioUnitarioAntesImpuestos = this.state.precioUnitarioAntesImpuestos;
    var iva = this.state.ivaEditar;
    var IVAvalorCatalogo = this.state.IVAvalorCatalogo;
    var nombreItemOfertar = this.state.itemOfertar.label;
    var idItemCotizacion = this.state.idItemCotizacionEdicionOfertado;

    var info = {
      codigo: codigo,
      idCotizacion: idCotizacion,
      precioUnitarioAntesImpuestos: precioUnitarioAntesImpuestos,
      IVAvalorCatalogo: IVAvalorCatalogo,
      iva: iva,
      idItemCotizacion: idItemCotizacion,
      nombreItemOfertar: nombreItemOfertar,
    };
    console.log(info);
    this.setState({ mensajeModificarValoresOfertado: "Actualizando" });

    axios
      .post(
        misConstantes.URL_CONSULTA + "/ServletActualizarCotizacionItemAbierto",
        info,
        { params: info }
      )
      .then(
        function (response) {
          var respuesta = response.data;
          var mensaje = respuesta.mensaje;
          this.setState({ mensajeModificarValoresOfertado: mensaje });
          if (respuesta.respuesta == "exito") {
            setTimeout(
              function () {
                this.setState({
                  mostrarEditarItemCotizacionOfertado: false,
                  mensajeModificarValoresOfertado: "",
                });
              }.bind(this),
              1000
            );
            this.cargarCotizacion();
            //				this.cargarItemCotizacions();
          }
        }.bind(this)
      )
      .catch(function (error) {});
  }

  editarItemCotizacion(event) {
    this.setState({ respuestaEditarItemCotizacion: "Editando" });
    // if (this.state.precioUnitarioAntesImpuestos < 0) {
    // 	this.setState({ respuestaEditarItemCotizacion: "Debe digitar el precio unitario antes impuestos" });
    // 	return;
    // }
    var codigo = localStorage.getItem("simuladores.proveedores.codigoUsuario");
    var idCotizacion = this.state.idCotizacion;
    var id = this.state.idEditarItemCotizacion;
    var descuentoPorcentaje = this.state.descuentoPorcentaje;
    var precioUnitarioAntesImpuestos = this.state.precioUnitarioAntesImpuestos;
    var iva = this.state.ivaEditar;
    var IVAvalorCatalogo = this.state.IVAvalorCatalogo;
    var cantidadOfertada = this.state.cantidadOfertada;

    var presentoLinea = document.getElementById("presentoLinea").value;
    var bpresentoLinea = true;
    if (presentoLinea == "0") {
      bpresentoLinea = false;
    }

    var valorCatalogo = this.state.valorCatalogo;

    var info = {
      codigo: codigo,
      id: id,
      idCotizacion: idCotizacion,
      descuento: descuentoPorcentaje,
      precioUnitarioAntesImpuestos: precioUnitarioAntesImpuestos,
      IVAvalorCatalogo: IVAvalorCatalogo,
      iva: iva,
      valorCatalogo: valorCatalogo,
      presentoLinea: bpresentoLinea,
      cantidadOfertada: cantidadOfertada,
    };

    this.setState({ respuestaEditarItemCotizacion: "Actualizando" });

    axios
      .post(
        misConstantes.URL_CONSULTA + "/ServletActualizarItemCotizacion",
        info,
        { params: info }
      )
      .then(
        function (response) {
          var respuesta = response.data;
          var mensaje = respuesta.mensaje;
          this.setState({ respuestaEditarItemCotizacion: mensaje });
          if (respuesta.respuesta == "exito") {
            setTimeout(
              function () {
                this.setState({
                  mostrarEditarItemCotizacion: false,
                  respuestaEditarItemCotizacion: "",
                });
              }.bind(this),
              1000
            );
            this.cargarCotizacion();
            //				this.cargarItemCotizacions();
          }
        }.bind(this)
      )
      .catch(function (error) {});
  }
  // ----------------------------------------
  // Cerrar cotizacion
  // ----------------------------------------
  cerrarCotizacion(event) {
    this.setState({ respuestaCerrarCotizacion: "Enviando" });

    var codigo = localStorage.getItem("simuladores.proveedores.codigoUsuario");
    var idCotizacion = this.state.idCotizacion;

    var info = { codigo: codigo, idCotizacion: idCotizacion };
    console.log(this.state.esAdjudicacionMultiple, this.state.seleccionoMarca);
    if (this.state.esAdjudicacionMultiple) {
      if (this.state.seleccionoMarca) {
        this.setState({ respuestaCerrarCotizacion: "Enviando" });
      } else {
        this.setState({
          respuestaCerrarCotizacion:
            "Debe seleccionar una marca para su cotizacion",
        });
        return;
      }
    } else {
      this.setState({ mensajeRespuestaEnviarCotizacion: "Enviando" });
    }

    axios
      .post(misConstantes.URL_CONSULTA + "/ServletCerrarCotizacion", info, {
        params: info,
      })
      .then(
        function (response) {
          var respuesta = response.data;
          var mensaje = respuesta.mensaje;
          this.setState({ respuestaCerrarCotizacion: mensaje });
          if (respuesta.respuesta == "exito") {
            window.location.reload();
          }
        }.bind(this)
      )
      .catch(function (error) {});
  }
  // ----------------------------------------
  // Chat
  // ----------------------------------------
  // Línea de estado del correo bajo el mensaje propio. Los campos vienen en el
  // JSON del mensaje (los escribe el hilo de envío en el back).
  // El HTML del chat se pinta con ReactHtmlParser; el clic en "Reenviar" se captura
  // por delegación en el panel de burbujas.

  // ----------------------------------------
  // Modificar texto
  // ----------------------------------------
  stringToFecha(fecha) {
    var ddfecha = new Date();

    var datos = fecha.split(" ");
    var dfecha = datos[0].split("/");
    var dhora = datos[1].split(":");

    ddfecha.setFullYear(dfecha[2]);
    ddfecha.setMonth(parseInt(dfecha[1]) - 1);
    ddfecha.setDate(dfecha[0]);

    ddfecha.setHours(dhora[0]);
    ddfecha.setMinutes(dhora[1]);
    ddfecha.setSeconds(0);

    return ddfecha;
  }
  cuentaRegresiva() {
    var sfechaRespuesta = this.state.fechaRespuesta;

    var dfechaRespuesta = this.stringToFecha(sfechaRespuesta);
    var tfechaRespuesta = dfechaRespuesta.getTime();
    var ahora = new Date().getTime();

    var distance = tfechaRespuesta - ahora;

    if (distance < 0) {
      this.setState({
        colorContador: "#e69202",
        mensajeContador: "none",
        mensajeContadorVencido: "initial",
        mostrarBotones: "none",
      });
      this.cargarItemCotizacions();
    } else {
      var days = Math.floor(distance / (1000 * 60 * 60 * 24));
      var hours = Math.floor(
        (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );
      var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      this.setState({
        diasCuentaRegresiva: days,
        horasCuentaRegresiva: hours,
        minutosCuentaRegresiva: minutes,
        colorContador: "#1564c1",
        mensajeContador: "initial",
        mensajeContadorVencido: "none",
      });
    }

    setTimeout(
      function () {
        this.cuentaRegresiva();
      }.bind(this),
      60000
    );
  }
  // ------------------------------------------------------------------------------------------------------
  // ArchivoProveedorProcesoSimulacion
  // ------------------------------------------------------------------------------------------------------
  handleCloseInsertarArchivoProveedorProcesoSimulacion(event) {
    this.setState({ mostrarInsertarArchivoProveedorProcesoSimulacion: false });
  }

  handleCloseEditarArchivoProveedorProcesoSimulacion(event) {
    this.setState({ mostrarEditarArchivoProveedorProcesoSimulacion: false });
  }
  handleCloseEliminarArchivoProveedorProcesoSimulacion(event) {
    this.setState({ mostrarEliminarArchivoProveedorProcesoSimulacion: false });
  }

  cargarArchivoProveedorProcesoSimulacions() {
    var codigo = localStorage.getItem("simuladores.proveedores.codigoUsuario");
    var idCotizacion = this.state.idCotizacion;
    var idSimulacion = this.state.idSimulacion;
    var info = { codigo: codigo, idCotizacion: idCotizacion };
    var cotizacion = this.state.cotizacion;
    axios
      .post(
        misConstantes.URL_CONSULTA +
          "/ServletArchivoProveedorProcesoSimulacionsJSON",
        info,
        { params: info }
      )
      .then(
        function (response) {
          var datosFinales = response.data;

          //			alert( cotizacion );

          var columns = this.state.columnasArchivos;
          if (cotizacion.estadoCierre == 2 || cotizacion.estadoCierre == 3) {
            var columns = this.state.columnasArchivosCerrada;
          }
          //			alert( "111" );
          //			https://apisimuladores.colombiacompra.gov.co/simuladorProveedor/descargarArchivoProveedorCotizacion?idSimulacion=22&idCotizacion=47&id=8
          var rows = [];
          //			alert( "2222" );
          for (var i = 0; i < datosFinales.length; i++) {
            const identificador = datosFinales[i].id + "";
            var urlDescarga =
              misConstantes.URL_CONSULTA +
              "/descargarArchivoProveedorCotizacion?idSimulacion=" +
              idSimulacion +
              "&idCotizacion=" +
              idCotizacion +
              "&id=" +
              identificador;

            var row = {
              nombre: <a href={urlDescarga}>{datosFinales[i].nombre}</a>,
              descripcion: datosFinales[i].descripcion,

              botones: (
                <div style={{ width: "100%", textAlign: "center" }}>
                  <a
                    href=""
                    onClick={(event) =>
                      this.handleShowEditarArchivoProveedorProcesoSimulacion(
                        event,
                        identificador + ""
                      )
                    }
                  >
                    <i class="fas fa-edit"></i>
                  </a>
                  &nbsp;
                  <a
                    href=""
                    onClick={(event) =>
                      this.handleShowEliminarArchivoProveedorProcesoSimulacion(
                        event,
                        identificador + ""
                      )
                    }
                    style={{ color: "red" }}
                  >
                    <i class="fas fa-trash"></i>
                  </a>
                </div>
              ),
            };
            rows.push(row);
          }
          //			alert( "3333" );
          var archivos = { columns: columns, rows: rows };
          this.setState({ archivos: archivos });
        }.bind(this)
      )
      .catch(function (error) {});
  }

  // ----------------------------------------
  // Insertar ArchivoProveedorProcesoSimulacion
  // ----------------------------------------
  handleShowInsertarArchivoProveedorProcesoSimulacion(event) {
    event.preventDefault();
    this.setState({ mostrarInsertarArchivoProveedorProcesoSimulacion: true });
  }
  insertarNombreInsertarArchivoProveedorProcesoSimulacion(event) {
    var nombreInsertarArchivoProveedorProcesoSimulacion = event.target.value;
    this.setState({
      nombreInsertarArchivoProveedorProcesoSimulacion:
        nombreInsertarArchivoProveedorProcesoSimulacion,
    });
  }
  insertarDescripcionInsertarArchivoProveedorProcesoSimulacion(event) {
    var descripcionInsertarArchivoProveedorProcesoSimulacion =
      event.target.value;
    this.setState({
      descripcionInsertarArchivoProveedorProcesoSimulacion:
        descripcionInsertarArchivoProveedorProcesoSimulacion,
    });
  }

  formularioInsertarArchivoProveedorProcesoSimulacion(event) {
    event.preventDefault();
    this.insertarArchivoProveedorProcesoSimulacion(event);
  }
  insertarArchivoProveedorProcesoSimulacion(event) {
    this.setState({
      respuestaInsertarArchivoProveedorProcesoSimulacion: "Insertando",
    });

    var codigo = localStorage.getItem("simuladores.proveedores.codigoUsuario");
    var descripcion =
      this.state.descripcionInsertarArchivoProveedorProcesoSimulacion;

    var formData = new FormData();
    var archivo = this.state.selectedFile;
    formData.append("archivo", archivo);
    formData.append("codigo", codigo);
    formData.append("descripcion", descripcion);
    formData.append("idSimulacion", this.state.idSimulacion);
    formData.append("idCotizacion", this.state.idCotizacion);

    this.setState({
      respuestaInsertarArchivoProveedorProcesoSimulacion: "Insertando",
    });

    axios
      .post(
        misConstantes.URL_CONSULTA +
          "/ServletInsertarArchivoProveedorProcesoSimulacion",
        formData,
        { headers: { "Content-Type": "multipart/form-data" } }
      )
      .then(
        function (response) {
          var respuesta = response.data;
          if (respuesta.respuesta == "exito") {
            this.cargarArchivoProveedorProcesoSimulacions();
            this.setState({
              mostrarInsertarArchivoProveedorProcesoSimulacion: false,
              nombreInsertarArchivoProveedorProcesoSimulacion: "",
              descripcionInsertarArchivoProveedorProcesoSimulacion: "",
              respuestaInsertarArchivoProveedorProcesoSimulacion: "",
            });
          } else {
            this.setState({
              respuestaInsertarArchivoProveedorProcesoSimulacion:
                respuesta.mensaje,
            });
          }
        }.bind(this)
      )
      .catch(function (error) {});
  }

  // ----------------------------------------
  // Editar ArchivoProveedorProcesoSimulacion
  // ----------------------------------------
  handleShowEditarArchivoProveedorProcesoSimulacion(event, id) {
    event.preventDefault();
    var codigo = localStorage.getItem("simuladores.proveedores.codigoUsuario");
    var idCotizacion = this.state.idCotizacion;
    this.setState({
      mostrarEditarArchivoProveedorProcesoSimulacion: true,
      idArchivoProveedorProcesoSimulacionEditar: id,
      respuestaEditarArchivoProveedorProcesoSimulacion: "Cargando",
    });
    var info = { codigo: codigo, id: id, idCotizacion: idCotizacion };
    axios
      .post(
        misConstantes.URL_CONSULTA +
          "/ServletArchivoProveedorProcesoSimulacion",
        info,
        { params: info }
      )
      .then(
        function (response) {
          var archivoProveedorProcesoSimulacion = response.data;

          const nombre = archivoProveedorProcesoSimulacion.nombre;
          const descripcion = archivoProveedorProcesoSimulacion.descripcion;

          this.setState({
            nombreEditarArchivoProveedorProcesoSimulacion: nombre,
            descripcionEditarArchivoProveedorProcesoSimulacion: descripcion,
            respuestaEditarArchivoProveedorProcesoSimulacion: "",
            idEditarArchivoProveedorProcesoSimulacion: id,
          });
        }.bind(this)
      )
      .catch(function (error) {});
  }
  modificarNombreEditarArchivoProveedorProcesoSimulacion(event) {
    var nombreEditarArchivoProveedorProcesoSimulacion = event.target.value;
    this.setState({
      nombreEditarArchivoProveedorProcesoSimulacion:
        nombreEditarArchivoProveedorProcesoSimulacion,
    });
  }
  modificarDescripcionEditarArchivoProveedorProcesoSimulacion(event) {
    var descripcionEditarArchivoProveedorProcesoSimulacion = event.target.value;
    this.setState({
      descripcionEditarArchivoProveedorProcesoSimulacion:
        descripcionEditarArchivoProveedorProcesoSimulacion,
    });
  }

  formularioEditarArchivoProveedorProcesoSimulacion(event) {
    event.preventDefault();
    this.editarArchivoProveedorProcesoSimulacion(event);
  }
  editarArchivoProveedorProcesoSimulacion(event) {
    this.setState({
      respuestaEditarArchivoProveedorProcesoSimulacion: "Editando",
    });

    var codigo = localStorage.getItem("simuladores.proveedores.codigoUsuario");
    var id = this.state.idEditarArchivoProveedorProcesoSimulacion;
    var idCotizacion = this.state.idCotizacion;

    var nombre = this.state.nombreEditarArchivoProveedorProcesoSimulacion;
    var descripcion =
      this.state.descripcionEditarArchivoProveedorProcesoSimulacion;

    var info = {
      codigo: codigo,
      id: id,
      idCotizacion: idCotizacion,
      nombre: nombre,
      descripcion: descripcion,
    };

    axios
      .post(
        misConstantes.URL_CONSULTA +
          "/ServletEditarArchivoProveedorProcesoSimulacion",
        info,
        { params: info }
      )
      .then(
        function (response) {
          var respuesta = response.data;
          if (respuesta.respuesta == "exito") {
            this.cargarArchivoProveedorProcesoSimulacions();
            this.setState({
              mostrarEditarArchivoProveedorProcesoSimulacion: false,
              nombreEditarArchivoProveedorProcesoSimulacion: "",
              descripcionEditarArchivoProveedorProcesoSimulacion: "",
              respuestaEditarArchivoProveedorProcesoSimulacion: "",
            });
          } else {
            this.setState({
              respuestaEditarArchivoProveedorProcesoSimulacion:
                respuesta.mensaje,
            });
          }
        }.bind(this)
      )
      .catch(function (error) {});
  }

  // ----------------------------------------
  // Eliminar ArchivoProveedorProcesoSimulacion
  // ----------------------------------------
  changeHandler(event) {
    this.setState({ selectedFile: event.target.files[0] });
  }
  handleShowEliminarArchivoProveedorProcesoSimulacion(event, id) {
    event.preventDefault();
    var codigo = localStorage.getItem("simuladores.proveedores.codigoUsuario");
    var idCotizacion = this.state.idCotizacion;
    this.setState({
      mostrarEliminarArchivoProveedorProcesoSimulacion: true,
      idEliminarArchivoProveedorProcesoSimulacion: id,
      respuestaEliminarArchivoProveedorProcesoSimulacion: "Cargando",
    });
    var info = { codigo: codigo, id: id, idCotizacion: idCotizacion };
    axios
      .post(
        misConstantes.URL_CONSULTA +
          "/ServletArchivoProveedorProcesoSimulacion",
        info,
        { params: info }
      )
      .then(
        function (response) {
          var archivoProveedorProcesoSimulacion = response.data;
          const nombre = archivoProveedorProcesoSimulacion.nombre;
          const id = archivoProveedorProcesoSimulacion.id;
          this.setState({
            nombreEliminarArchivoProveedorProcesoSimulacion: nombre,
            respuestaEliminarArchivoProveedorProcesoSimulacion: "",
            idEliminarArchivoProveedorProcesoSimulacion: id,
          });
        }.bind(this)
      )
      .catch(function (error) {});
  }
  eliminarArchivoProveedorProcesoSimulacion(event) {
    this.setState({
      respuestaEliminarArchivoProveedorProcesoSimulacion: "Eliminando",
    });

    var codigo = localStorage.getItem("simuladores.proveedores.codigoUsuario");
    var id = this.state.idEliminarArchivoProveedorProcesoSimulacion;
    var idCotizacion = this.state.idCotizacion;

    var info = {
      codigo: codigo,
      idArchivoProveedorProcesoSimulacion: id,
      idCotizacion: idCotizacion,
    };

    axios
      .post(
        misConstantes.URL_CONSULTA +
          "/ServletEliminarArchivoProveedorProcesoSimulacion",
        info,
        { params: info }
      )
      .then(
        function (response) {
          var respuesta = response.data;
          if (respuesta.respuesta == "exito") {
            this.cargarArchivoProveedorProcesoSimulacions();
            this.setState({
              mostrarEliminarArchivoProveedorProcesoSimulacion: false,
            });
            setTimeout(
              function () {
                this.setState({
                  nombreEliminarArchivoProveedorProcesoSimulacion: "",
                  respuestaEliminarArchivoProveedorProcesoSimulacion: "",
                });
              }.bind(this),
              1000
            );
          } else {
            this.setState({
              respuestaEliminarArchivoProveedorProcesoSimulacion:
                respuesta.mensaje,
            });
          }
        }.bind(this)
      )
      .catch(function (error) {});
  }

  // ----------------------------------------
  // Cargar ArchivoEntidadProcesoSimulacion
  // ----------------------------------------
  cargarArchivoEntidadProcesoSimulacions() {
    //		alert( "11111" );
    //		datosArchivosSimulacion: {columns: columnasArchivosSimulacion, rows:[]},

    var codigo = localStorage.getItem("simuladores.proveedores.codigoUsuario");
    var idCotizacion = this.state.idCotizacion;
    var idSimulacion = this.state.idSimulacion;
    var info = { codigo: codigo, idCotizacion: idCotizacion };

    axios
      .post(
        misConstantes.URL_CONSULTA + "/ServletArchivosEntidadCotizacion",
        info,
        { params: info }
      )
      .then(
        function (response) {
          var datosFinales = response.data;

          var columns = this.state.columnasArchivosSimulacion;
          var rows = [];
          for (var i = 0; i < datosFinales.length; i++) {
            {
              /** var anombre = ReactHtmlParser( "<a href = '" + misConstantes.URL_CONSULTA  + "/descargarArchivoEntidadProcesoSimulacion?idSimulacion=" + idSimulacion + "&id=" + datosFinales[i].id + "' target = '_blank'>" + datosFinales[i].nombre + "</a>" );*/
            }
            {
              /** const identificador = datosFinales[i].id + ""; */
            }

            var anombre = (
              <>
                <a
                  href={
                    misConstantes.URL_CONSULTA +
                    "/descargarArchivoEntidadProcesoSimulacion?idSimulacion=" +
                    idSimulacion +
                    "&id=" +
                    datosFinales[i].id
                  }
                  target="_blank"
                >
                  {datosFinales[i].nombre}
                </a>
              </>
            );

            var row = {
              nombre: anombre,
              descripcion: datosFinales[i].descripcion,
            };
            rows.push(row);
          }

          var datosArchivosSimulacion = { columns: columns, rows: rows };
          this.setState({ datosArchivosSimulacion: datosArchivosSimulacion });
        }.bind(this)
      )
      .catch(function (error) {});
  }

  // ----------------------------------------
  // Cargar gravamenes
  // ----------------------------------------
  cargarSimulacionGravamens() {
    var codigo = localStorage.getItem("simuladores.proveedores.codigoUsuario");
    var idCotizacion = this.state.idCotizacion;

    var info = { codigo: codigo, idCotizacion: idCotizacion };

    axios
      .post(misConstantes.URL_CONSULTA + "/ServletGravamenesCotizacion", info, {
        params: info,
      })
      .then(
        function (response) {
          var datosFinales = response.data;

          var columns = this.state.columnasGravamenesSimulacion;
          var rows = [];
          for (var i = 0; i < datosFinales.length; i++) {
            const identificador = datosFinales[i].id + "";
            var valor = datosFinales[i].valor + "%";
            var row = {
              nombre: datosFinales[i].nombre,
              valor: valor,
            };
            rows.push(row);
          }

          var gravamenesSimulacion = { columns: columns, rows: rows };
          this.setState({ gravamenesSimulacion: gravamenesSimulacion });
        }.bind(this)
      )
      .catch(function (error) {});
  }

  // ----------------------------------------
  // Enviar cotizacion
  // ----------------------------------------
  enviarCotizacion() {
    var codigo = localStorage.getItem("simuladores.proveedores.codigoUsuario");
    var idCotizacion = this.state.idCotizacion;

    var info = { codigo: codigo, idCotizacion: idCotizacion };
    console.log(this.state.esAdjudicacionMultiple);
    if (this.state.esAdjudicacionMultiple) {
      if (this.state.seleccionoMarca) {
        this.setState({ mensajeRespuestaEnviarCotizacion: "Enviando" });
      } else {
        this.setState({
          mensajeRespuestaEnviarCotizacion:
            "Debe seleccionar una marca para su cotizacion",
        });
        return;
      }
    } else {
      this.setState({ mensajeRespuestaEnviarCotizacion: "Enviando" });
    }

    //this.setState({ mensajeRespuestaEnviarCotizacion: "Enviando" });

    axios
      .post(misConstantes.URL_CONSULTA + "/ServletEnviarCotizacion", info, {
        params: info,
      })
      .then(
        function (response) {
          var respuesta = response.data;
          this.setState({
            mensajeRespuestaEnviarCotizacion: respuesta.mensaje,
          });
          if (respuesta.respuesta == "exito") {
            setTimeout(
              function () {
                this.setState({ mostrarEnviarCotizacion: false });
              }.bind(this),
              1000
            );
          }
        }.bind(this)
      )
      .catch(function (error) {});
  }

  // ----------------------------------------
  // Descargar excel cotizacion
  // ----------------------------------------
  // descargarFormatoDescuento() {
  // 	var idCotizacion = this.state.idCotizacion;
  // 	window.open(
  // 		misConstantes.URL_CONSULTA +
  // 		"/descuentosCotizacion.xlsx?idCotizacion=" +
  // 		idCotizacion,
  // 		"_blank"
  // 	);
  // }

  descargarFormatoDescuento() {
    const { idCotizacion } = this.state;

    const url = `${misConstantes.URL_CONSULTA}/descuentosCotizacion.xlsx?idCotizacion=${idCotizacion}`;

    axios
      .get(url, { responseType: "blob" })
      .then((response) => {
        const blob = new Blob([response.data], {
          type: response.headers["content-type"],
        });
        const urlBlob = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = urlBlob;
        a.download = `descuentosCotizacion_${idCotizacion}.xlsx`;
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(urlBlob);
      })
      .catch((error) => {
        console.error("Error al descargar el formato de descuentos:", error);
      });
  }

  //   descargarFormatoPrecio() {
  //     var idCotizacion = this.state.idCotizacion;
  //     window.open(
  //       misConstantes.URL_CONSULTA +
  //         "/preciosCotizacion.xlsx?idCotizacion=" +
  //         idCotizacion,
  //       "_blank"
  //     );
  //   }

  descargarFormatoPrecio() {
    const { idCotizacion } = this.state;

    const url = `${misConstantes.URL_CONSULTA}/preciosCotizacion.xlsx?idCotizacion=${idCotizacion}`;

    axios
      .get(url, { responseType: "blob" })
      .then((response) => {
        const blob = new Blob([response.data], {
          type: response.headers["content-type"],
        });
        const urlBlob = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = urlBlob;
        a.download = `preciosCotizacion_${idCotizacion}.xlsx`;
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(urlBlob);
      })
      .catch((error) => {
        console.error("Error al descargar el formato de precios:", error);
      });
  }

  // ----------------------------------------
  // Descargar excel cotizacion
  // ----------------------------------------
  changeHandlerArchivo(event) {
    this.setState({ archivoCotizacion: event.target.files[0] });
  }
  subirCotizacion() {
    this.setState({ mostrarSubirPreciosMasivos: true });
  }
  handleCloseCargueMasivoPrecios() {
    this.setState({ mostrarSubirPreciosMasivos: false });
  }
  subirArchivoCargueMasivoDescuentos() {
    var codigo = localStorage.getItem("simuladores.proveedores.codigoUsuario");

    var formData = new FormData();
    var excel = this.state.archivoCotizacion;
    formData.append("archivo", excel);
    formData.append("codigo", codigo);
    formData.append("idCotizacion", this.state.idCotizacion);

    this.setState({
      mensajeCargandoArchivo: "Cargando archivo",
      mostrarMensajeCargando: "",
    });
    this.setState({
      respuestaSubirArchivoCargueMasivoPrecios:
        "Subiendo, puede tomar varios minutos",
    });
    axios
      .post(
        misConstantes.URL_CONSULTA + "/ServletSubirDescuentosCotizacionMasivo",
        formData,
        { headers: { "Content-Type": "multipart/form-data" } }
      )
      .then(
        function (response) {
          var respuesta = response.data;
          this.setState({
            respuestaSubirArchivoCargueMasivoPrecios: respuesta.mensaje,
          });
          if (respuesta.respuesta == "exito") {
            //				this.cargarItemCotizacions();
            this.setState({
              mostrarCargueMasivo: false,
              mostrarSubirPreciosMasivos: false,
            });
            this.setState({
              mensajeCargandoArchivo: "Cargando archivo",
              mostrarMensajeCargando: "",
            });
            setTimeout(
              function () {
                this.mensajeCargarArchivo();
              }.bind(this),
              2500
            );
          }
        }.bind(this)
      )
      .catch(function (error) {});
  }
  mensajeCargarArchivo() {
    var codigo = localStorage.getItem("simuladores.proveedores.codigoUsuario");
    var idCotizacion = this.state.idCotizacion;
    var info = { codigo: codigo, id: idCotizacion };
    this.setState({
      mensajeCargandoArchivo: "Cargando archivo",
      mostrarMensajeCargando: "",
    });

    axios
      .post(misConstantes.URL_CONSULTA + "/ServletCotizacion", info, {
        params: info,
      })
      .then(
        function (response) {
          var cotizacion = response.data;

          if (cotizacion.ocupado + "" == "true") {
            this.setState({
              mensajeCargandoArchivo: cotizacion.mensaje,
              mostrarMensajeCargando: "",
            });
            setTimeout(
              function () {
                this.mensajeCargarArchivo();
              }.bind(this),
              2500
            );
          } else {
            this.setState({
              mensajeCargandoArchivo: "",
              mostrarMensajeCargando: "none",
            });
          }
        }.bind(this)
      )
      .catch(function (error) {
        //			alert("Mal");
      });
  }

  // ----------------------------------------
  // actualizar valor
  // ----------------------------------------
  actualizarItemAbierto() {
    var codigo = localStorage.getItem("simuladores.proveedores.codigoUsuario");

    var idCotizacion = this.state.idCotizacion;
    var idItemCotizacion = this.state.idItemCotizacionEdicionAbierto;
    var iva = document.getElementById("ivaModificarItemAbierto").value;
    var precioUnitarioAntesImpuestos = document.getElementById(
      "precioUnitarioModificarItemAbierto"
    ).value;

    var info = {
      codigo: codigo,
      idCotizacion: idCotizacion,
      idItemCotizacion: idItemCotizacion,
      iva: iva,
      precioUnitarioAntesImpuestos: precioUnitarioAntesImpuestos,
    };

    this.setState({ mensajeModificarValoresAbierto: "Actualizando" });
    axios
      .post(
        misConstantes.URL_CONSULTA + "/ServletActualizarItemCotizacionAbierto",
        info,
        { params: info }
      )
      .then(
        function (response) {
          var respuesta = response.data;
          this.setState({ mensajeModificarValoresAbierto: respuesta.mensaje });
          if (respuesta.respuesta == "exito") {
            this.cargarCotizacion();
            this.cargarItemCotizacions();
            this.setState({ mostrarEditarItemCotizacionAbierto: false });
          }
        }.bind(this)
      )
      .catch(function (error) {});
  }
  // ----------------------------------------
  // Eliminar item
  // ----------------------------------------
  handleShowEliminarItemCotizacion(event, id, nombre) {
    event.preventDefault();
    this.setState({
      mostrarEliminarItemCotizacionProcesoSimulacion: true,
      idEliminarItemCotizacionSimulacion: id,
      nombreItemEliminarCotizacion: nombre,
    });
  }

  handleCloseEliminarItemProcesoSimulacion(event) {
    event.preventDefault();
    this.setState({ mostrarEliminarItemCotizacionProcesoSimulacion: false });
  }
  handleEliminarItemProcesoSimulacion(event) {
    event.preventDefault();

    var codigo = localStorage.getItem("simuladores.proveedores.codigoUsuario");

    var idCotizacion = this.state.idCotizacion;
    var idItemCotizacion = this.state.idEliminarItemCotizacionSimulacion;

    var info = {
      codigo: codigo,
      idCotizacion: idCotizacion,
      idItemCotizacion: idItemCotizacion,
    };

    this.setState({ respuestaEliminarItemProcesoSimulacion: "Eliminando" });
    axios
      .post(
        misConstantes.URL_CONSULTA + "/ServletEliminarItemCotizacion",
        info,
        { params: info }
      )
      .then(
        function (response) {
          var respuesta = response.data;
          this.setState({
            respuestaEliminarItemProcesoSimulacion: respuesta.mensaje,
          });
          if (respuesta.respuesta == "exito") {
            this.cargarCotizacion();
            this.cargarItemCotizacions();
            this.setState({
              mostrarEliminarItemCotizacionProcesoSimulacion: false,
            });
          }
        }.bind(this)
      )
      .catch(function (error) {});
  }
  // ----------------------------------------
  // Marca
  // ----------------------------------------
  handleAbrirCargaMarca(event, idItemCotizacion) {
    event.preventDefault();

    //		alert(  idItemCotizacion + " --- ");
    var codigo = localStorage.getItem("simuladores.proveedores.codigoUsuario");
    var idCotizacion = this.state.idCotizacion;
    var idItemCotizacion = idItemCotizacion;

    this.setState({
      mostrarCambiarMarca: true,
      idItemCotizacionMarca: idItemCotizacion,
    });
    var info = {
      codigo: codigo,
      id: idItemCotizacion,
      idCotizacion: idCotizacion,
    };

    axios
      .post(misConstantes.URL_CONSULTA + "/ServletItemCotizacion", info, {
        params: info,
      })
      .then(
        function (response) {
          var itemCotizacion = response.data;
          var marca = itemCotizacion.marca;
          if (marca == null || marca == "undefined" || marca == "") {
            marca = "";
          }

          var especificacionEquipo = itemCotizacion.especificacionEquipo;
          if (
            especificacionEquipo == null ||
            especificacionEquipo == "undefined" ||
            especificacionEquipo == ""
          ) {
            especificacionEquipo = "";
          }

          document.getElementById("marcaSolicitudMarca").value = marca;
          document.getElementById("especificacionSolicitudMarca").value =
            especificacionEquipo;
        }.bind(this)
      )
      .catch(function (error) {});
  }

  actualizarMarcaAdjudicacionMultiple(event, idItemCotizacion) {
    //		event.preventDefault();

    var codigo = localStorage.getItem("simuladores.proveedores.codigoUsuario");
    var idCotizacion = this.state.idCotizacion;
    var idItemCotizacion = this.state.idItemCotizacionMarca;
    var select = document.getElementById("marcaSolicitudMarca");
    var marca = select.value;

    const marcaSeleccionada = this.state.marcasProveedor.find(
      (m) => m.label === marca
    );
    //console.log(marcaSeleccionada);
    var idMarca = marcaSeleccionada?.value.value;
    console.log(marca, idMarca);
    var especificacionEquipo = document.getElementById(
      "especificacionSolicitudMarca"
    ).value;

    var info = {
      codigo: codigo,
      idItemCotizacion: idItemCotizacion,
      idCotizacion: idCotizacion,
      idMarca: idMarca,
      marca: marca,
      especificacionEquipo: especificacionEquipo,
    };

    this.setState({ respuestaMarca: "Actualizando" });

    axios
      .post(misConstantes.URL_CONSULTA + "/ServletActualizarMarca", info, {
        params: info,
      })
      .then(
        function (response) {
          var respuesta = response.data;

          //			alert( JSON.stringify( response.data ) );
          //
          var respuesta = response.data;
          this.setState({
            respuestaEliminarItemProcesoSimulacion: respuesta.mensaje,
          });
          if (respuesta.respuesta == "exito") {
            this.setState({ mostrarCambiarMarca: false, respuestaMarca: "" });
            this.cargarItemCotizacions();
          }
        }.bind(this)
      )
      .catch(function (error) {});

    axios
      .post(
        misConstantes.URL_CONSULTA + "/ServletActualizarMarcasProveedor",
        info,
        {
          params: info,
        }
      )
      .then(
        function (response) {
          var respuesta = response.data;

          this.setState({
            respuestaEliminarItemProcesoSimulacion: respuesta.mensaje,
          });
          if (respuesta.respuesta == "exito") {
            this.setState({ mostrarCambiarMarca: false, respuestaMarca: "" });
            this.cargarItemCotizacions();
          }
        }.bind(this)
      )
      .catch(function (error) {});
    this.setState({ seleccionoMarca: true });
  }

  actualizarMarca(event, idItemCotizacion) {
    //		event.preventDefault();

    var codigo = localStorage.getItem("simuladores.proveedores.codigoUsuario");
    var idCotizacion = this.state.idCotizacion;
    var idItemCotizacion = this.state.idItemCotizacionMarca;
    var idMarca = -1;
    var marca = document.getElementById("marcaSolicitudMarca").value;
    var especificacionEquipo = document.getElementById(
      "especificacionSolicitudMarca"
    ).value;

    var info = {
      codigo: codigo,
      idItemCotizacion: idItemCotizacion,
      idCotizacion: idCotizacion,
      idMarca: idMarca,
      marca: marca,
      especificacionEquipo: especificacionEquipo,
    };

    this.setState({ respuestaMarca: "Actualizando" });

    axios
      .post(misConstantes.URL_CONSULTA + "/ServletActualizarMarca", info, {
        params: info,
      })
      .then(
        function (response) {
          var respuesta = response.data;

          //			alert( JSON.stringify( response.data ) );
          //
          var respuesta = response.data;
          this.setState({
            respuestaEliminarItemProcesoSimulacion: respuesta.mensaje,
          });
          if (respuesta.respuesta == "exito") {
            this.setState({ mostrarCambiarMarca: false, respuestaMarca: "" });
            this.cargarItemCotizacions();
          }
        }.bind(this)
      )
      .catch(function (error) {});
  }
  handleCloseCargaMarca(event) {
    if (event != null) {
      event.preventDefault();
    }
    this.setState({ mostrarCambiarMarca: false });
  }

  // ----------------------------------------
  //
  // ----------------------------------------
  handleCloseInsertarCategoriaProductoCotizacionValor(event) {
    this.setState({ mostrarInsertarCategoriaProductoCotizacionValor: false });
  }

  handleCloseEditarCategoriaProductoCotizacionValor(event) {
    this.setState({ mostrarEditarCategoriaProductoCotizacionValor: false });
  }
  handleCloseEliminarCategoriaProductoCotizacionValor(event) {
    this.setState({ mostrarEliminarCategoriaProductoCotizacionValor: false });
  }

  handleShowInsertarCategoriaProductoCotizacionValor(event) {
    event.preventDefault();
    this.setState(
      { mostrarInsertarCategoriaProductoCotizacionValor: true },
      function () {
        var codigo = localStorage.getItem(
          "simuladores.proveedores.codigoUsuario"
        );
        var idCotizacion = this.state.idCotizacion;

        var info = { codigo: codigo, idCotizacion: idCotizacion };
        axios
          .post(
            misConstantes.URL_CONSULTA + "/ServletCategoriasProducto",
            info,
            { params: info }
          )
          .then(
            function (response) {
              var categoriasProducto = response.data;
              var select = document.getElementById(
                "categoriaProductoInsertarDescuentoCategoria"
              );

              for (var i = 0; i < categoriasProducto.length; i++) {
                var opt = document.createElement("option");
                opt.value = categoriasProducto[i].id;
                opt.innerHTML = categoriasProducto[i].nombre;
                select.appendChild(opt);
              }
            }.bind(this)
          )
          .catch(function (error) {});
      }.bind(this)
    );
  }
  insertarCategoriaProductoCotizacionValor() {
    var codigo = localStorage.getItem("simuladores.proveedores.codigoUsuario");
    var idCotizacion = this.state.idCotizacion;
    var idCategoriaProducto = document.getElementById(
      "categoriaProductoInsertarDescuentoCategoria"
    ).value;
    var valor = document.getElementById(
      "valorProductoInsertarDescuentoCategoria"
    ).value;
    var info = {
      codigo: codigo,
      idCotizacion: idCotizacion,
      idCategoriaProducto: idCategoriaProducto,
      valor: valor,
    };

    this.setState({
      respuestaInsertarCategoriaProductoCotizacionValor: "Insertando",
    });
    axios
      .post(
        misConstantes.URL_CONSULTA +
          "/ServletInsertarCategoriaProductoCotizacionValor",
        info,
        { params: info }
      )
      .then(
        function (response) {
          var respuesta = response.data;
          this.setState({
            respuestaInsertarCategoriaProductoCotizacionValor:
              respuesta.mensaje,
          });

          if (respuesta.respuesta == "exito") {
            window.location.reload();
          }
        }.bind(this)
      )
      .catch(function (error) {});
  }

  cargarCategoriaProductoCotizacionValor() {
    var codigo = localStorage.getItem("simuladores.proveedores.codigoUsuario");
    var idCotizacion = this.state.idCotizacion;

    var info = { codigo: codigo, idCotizacion: idCotizacion };
    //		datosCategoriasProducto: {columns: columnasCategoriasProducto, rows:[]},
    this.setState({
      respuestaInsertarCategoriaProductoCotizacionValor: "Insertando",
    });
    axios
      .post(
        misConstantes.URL_CONSULTA +
          "/ServletCategoriaProductoCotizacionValorsJSON",
        info,
        { params: info }
      )
      .then(
        function (response) {
          var datosFinales = response.data;

          var columns = this.state.datosCategoriasProducto.columns;
          var rows = [];
          for (var i = 0; i < datosFinales.length; i++) {
            const identificador = datosFinales[i].id + "";
            var nombreCategoriaProducto =
              datosFinales[i].categoriaProducto.nombre + "";
            var row = {
              valor: datosFinales[i].valor,
              categoria: datosFinales[i].categoriaProducto.nombre,
              botones: (
                <div style={{ width: "100%", textAlign: "center" }}>
                  <a
                    href=""
                    onClick={(event) =>
                      this.handleShowEliminarCategoriaProductoCotizacionValor(
                        event,
                        identificador + "",
                        nombreCategoriaProducto + ""
                      )
                    }
                    style={{ color: "red" }}
                  >
                    <i class="fas fa-trash"></i>
                  </a>
                </div>
              ),
            };
            rows.push(row);
          }

          var datosCategoriasProducto = { columns: columns, rows: rows };
          this.setState({ datosCategoriasProducto: datosCategoriasProducto });
        }.bind(this)
      )
      .catch(function (error) {});
  }
  handleShowEliminarCategoriaProductoCotizacionValor(event, id, nombre) {
    event.preventDefault();
    this.setState({
      mostrarEliminarCategoriaProductoCotizacionValor: true,
      nombreEliminarCategoriaProductoCotizacionValor: nombre,
      idCategoriaProductoEliminar: id,
    });
  }
  eliminarCategoriaProductoCotizacionValor() {
    var codigo = localStorage.getItem("simuladores.proveedores.codigoUsuario");
    var idCotizacion = this.state.idCotizacion;
    var id = this.state.idCategoriaProductoEliminar;
    this.setState({
      respuestaEliminarCategoriaProductoCotizacionValor: "Eliminando",
    });
    var info = {
      codigo: codigo,
      idCotizacion: idCotizacion,
      idCategoriaProductoCotizacionValor: id,
    };
    axios
      .post(
        misConstantes.URL_CONSULTA + "/ServletEliminarCategoriaProductoValor",
        info,
        { params: info }
      )
      .then(
        function (response) {
          var datosFinales = response.data;
          this.setState({
            respuestaEliminarCategoriaProductoCotizacionValor:
              datosFinales.mensaje,
          });
          if (datosFinales.respuesta == "exito") {
            this.cargarCotizacion();
            this.cargarProductos();
            this.cargarCategoriaProductoCotizacionValor();
          }
        }.bind(this)
      )
      .catch(function (error) {});
  }

  // ---------------------------------------
  //
  // ---------------------------------------
  handleCloseCargueMasivoPreciosPrecio() {
    this.setState({
      mostrarSubirPreciosPrecioMasivos: false,
      respuestaSubirArchivoCargueMasivoPrecios: "",
    });
  }
  subirCargueMasivoPreciosPrecio() {
    this.setState({
      mostrarSubirPreciosPrecioMasivos: true,
      respuestaSubirArchivoCargueMasivoPrecios: "",
    });
  }
  changeHandlerArchivoPrecioFinal(event) {
    this.setState({ archivoCotizacionPrecio: event.target.files[0] });
  }

  changeHandlerArchivoPrecio(event) {
    this.setState({ selectedFile: event.target.files[0] });
  }

  subirArchivoCargueMasivoPreciosPrecio() {
    var codigo = localStorage.getItem("simuladores.proveedores.codigoUsuario");

    var formData = new FormData();
    var excel = this.state.archivoCotizacionPrecio;
    formData.append("archivo", excel);
    formData.append("codigo", codigo);
    formData.append("idCotizacion", this.state.idCotizacion);

    this.setState({
      mensajeCargandoArchivo: "Cargando archivo",
      mostrarMensajeCargando: "",
    });
    this.setState({
      respuestaSubirArchivoCargueMasivoPreciosPrecio:
        "Subiendo, puede tomar varios minutos",
    });
    axios
      .post(
        misConstantes.URL_CONSULTA + "/ServletSubirPreciosCotizacionMasivo",
        formData,
        { headers: { "Content-Type": "multipart/form-data" } }
      )
      .then(
        function (response) {
          var respuesta = response.data;
          this.setState({
            respuestaSubirArchivoCargueMasivoPreciosPrecio: respuesta.mensaje,
          });
          if (respuesta.respuesta == "exito") {
            //				this.cargarItemCotizacions();
            this.setState({
              mostrarSubirPreciosPrecioMasivos: false,
              respuestaSubirArchivoCargueMasivoPrecios: "",
            });
            this.setState({
              mensajeCargandoArchivo: "Cargando archivo",
              mostrarMensajeCargando: "",
            });
            setTimeout(
              function () {
                this.mensajeCargarArchivo();
              }.bind(this),
              2500
            );
          }
        }.bind(this)
      )
      .catch(function (error) {});
  }

  actualizarVisto() {
    var codigo = localStorage.getItem("simuladores.proveedores.codigoUsuario");
    var idCotizacion = this.state.idCotizacion;
    var info = { codigo: codigo, idCotizacion: idCotizacion };

    axios
      .post(
        misConstantes.URL_CONSULTA + "/ServletCotizacionActualizarVisto",
        info,
        { params: info }
      )
      .then(function (response) {}.bind(this))
      .catch(function (error) {});
  }

  cargarVisualizacionBotonSimuladorEntidad() {
    var codigo = localStorage.getItem("simuladores.proveedores.codigoUsuario");
    var idCotizacion = this.state.idCotizacion;

    //		var visualizacionBotonSimuladorEntidad = {insertarArchivo: "", editarCantidad: "", insertarItemBlanco: "", descargaArchivoMantenimiento:"", editarSimulacion:"", insertarGravamen:""};
    //		visualizacionBotonSimuladorEntidad

    var info = { codigo: codigo, idCotizacion: idCotizacion };
    axios
      .post(
        misConstantes.URL_CONSULTA +
          "/ServletVisualizacionBotonSimuladorProveedor",
        info,
        { params: info }
      )
      .then(
        function (response) {
          var respuesta = response.data;
          //			alert( JSON.stringify(respuesta) );

          var insertarArchivo = "";
          if (respuesta.insertarArchivo == false) {
            insertarArchivo = "none";
          }
          var ivaTodosProductos = "";
          if (respuesta.ivaTodosProductos == false) {
            ivaTodosProductos = "none";
          }
          var descuentoTodosProductos = "";
          if (respuesta.descuentoTodosProductos == false) {
            descuentoTodosProductos = "none";
          }
          var cargueMasivoDescuento = "";
          if (respuesta.cargueMasivoDescuento == false) {
            cargueMasivoDescuento = "none";
          }
          var cargueMasivoPrecio = "";
          if (respuesta.cargueMasivoPrecio == false) {
            cargueMasivoPrecio = "none";
          }
          var descuentoCategoria = "";
          if (respuesta.descuentoCategoria == false) {
            descuentoCategoria = "none";
          }

          var visualizacionBotonSimuladorProveedor = {
            insertarArchivo: insertarArchivo,
            ivaTodosProductos: ivaTodosProductos,
            descuentoTodosProductos: descuentoTodosProductos,
            cargueMasivoDescuento: cargueMasivoDescuento,
            cargueMasivoPrecio: cargueMasivoPrecio,
            descuentoCategoria: descuentoCategoria,
          };
          this.setState({
            visualizacionBotonSimuladorProveedor:
              visualizacionBotonSimuladorProveedor,
          });

          //			"estado":1,"insertarArchivo":true,"editarCantidad":true,"insertarItemBlanco":true,"descargaArchivoMantenimiento":true,"editarSimulacion":true,"insertarGravamen":true,"id":1}
        }.bind(this)
      )
      .catch(function (error) {
        alert("11111");
      });
  }
  //var columnasResultadoProveedoresValidasMontoAgotable = [
  //											{ field: "proveedor", label: "Proveedor", attributes: {'width':'45%'} },
  //											{ field: "valor", label: "Valor", width :  "25%" , attributes: {'width':'25%', 'align': 'center'} },
  //											{ field: "cantidad", label: "Cantidad", width :  "20%" , attributes: {'width':'25%', 'align': 'center'} },
  //											{ field: "botones", label: "", sort: 'asc', width :  "10%" , attributes: { 'width': '10%', 'align': 'center' } }
  //
  // 											];
  cargarSimulacionesProveedores() {
    var columnasResultadoProveedoresValidas = this.state.simulaciones.columns;

    var idCotizacion = this.state.idCotizacion;
    var codigo = localStorage.getItem("simuladores.proveedores.codigoUsuario");

    var info = { codigo: codigo, idCotizacion: idCotizacion };

    axios
      .post(
        misConstantes.URL_CONSULTA + "/ServletSimulacionProveedorsJSON",
        info,
        { params: info }
      )
      .then(
        function (response) {
          var datosFinales = response.data;
          var rows = [];
          var cargando = false;
          var proveedoresCargando = "";
          for (var i = 0; i < datosFinales.length; i++) {
            const identificador = datosFinales[i].id + "";
            var valor = datosFinales[i].svalorTotal;
            var cantidad = datosFinales[i].scantidad;
            var proveedor =
              datosFinales[i].proveedor.nit +
              ". " +
              datosFinales[i].proveedor.nombre;
            if (datosFinales[i].mensaje != "") {
              proveedor = (
                <>
                  {proveedor}
                  <br />
                  <span style={{ fontStyle: "italic" }}>
                    {datosFinales[i].mensaje}
                  </span>
                </>
              );
            }
            if (datosFinales[i].calculando + "" == "true") {
              cargando = true;
              proveedoresCargando = (
                <>
                  {proveedoresCargando}
                  <br />
                  {datosFinales[i].proveedor.nombre}
                </>
              );
            }

            var row = {
              proveedor: proveedor,
              valor: valor,
              cantidad: cantidad,
              respuesta: <>datosFinales[i].respuesta</>,
              botones: (
                <div style={{ width: "100%", textAlign: "center" }}>
                  <Link
                    to={
                      "/simulacion-proveedor/" +
                      this.state.idCotizacion +
                      "/" +
                      datosFinales[i].id
                    }
                  >
                    <i class="fas fa-info-circle"></i>
                  </Link>
                </div>
              ),
            };
            rows.push(row);
          }

          var simulaciones = {
            columns: columnasResultadoProveedoresValidas,
            rows: rows,
          };

          this.setState({ simulaciones: simulaciones });

          //			if( cargando == true ){
          //				proveedoresCargando = <>{  proveedoresCargando }<br/></>;
          //				this.setState( {mostrarCargandoSimulaciones: "", mensajeCargando:proveedoresCargando} );
          //
          //			}else{
          //				this.setState( {mostrarCargandoSimulaciones: "none", mensajeCargando:<></>} );
          //			}
        }.bind(this)
      )
      .catch(function (error) {});
  }

  // -----------------------------------
  // Subir archivo chat
  // -----------------------------------

  cargarCotizaciones() {
    var columnasCotizacionesOtrosProveedores =
      this.state.columnasCotizacionesOtrosProveedores;

    var idCotizacion = this.state.idCotizacion;
    var codigo = localStorage.getItem("simuladores.proveedores.codigoUsuario");
    var info = { codigo: codigo, idCotizacion: idCotizacion };

    axios
      .post(
        misConstantes.URL_CONSULTA + "/ServletCotizacionesCotizacion",
        info,
        { params: info }
      )
      .then(
        function (response) {
          //			{ field: "estadoEnvio", label: "Envio", sort: 'asc', width :  "20%" , attributes: { 'width': '10%', 'align': 'center' } },
          //								{ field: "estadoCierre", label: "Ultima oferta", sort: 'asc', width :  "20%" , attributes: { 'width': '10%', 'align': 'center' } }

          var datosFinales = response.data;

          var rows = [];
          var todasCotizacionesCerradas = true;
          var mostrarBotonCerrarProcesoCotizacion = "none";
          for (var i = 0; i < datosFinales.length; i++) {
            const consecutivo = datosFinales[i].consecutivo + "";
            const nombreProveedor = datosFinales[i].proveedor.nombre + "";
            const stotal = datosFinales[i].stotal + "";
            const scantidad = datosFinales[i].scantidadOfertada + "";

            var iconoEnvio = ReactHtmlParser(
              '<div style = "width: 100%; text-align: center;"><i class="fas fa-check-double"></i></div>'
            );
            var iconoCierre = ReactHtmlParser(
              '<div style = "width: 100%; text-align: center;"><i class="fas fa-check-double"></i></div>'
            );
            if (datosFinales[i].estadoCierre == 1) {
              iconoCierre = ReactHtmlParser(
                '<div style = "width: 100%; text-align: center;"><i class="fas fa-clock"></i></div>'
              );
              todasCotizacionesCerradas = false;
            }
            if (datosFinales[i].estadoEnvio == 1) {
              iconoEnvio = ReactHtmlParser(
                '<div style = "width: 100%; text-align: center;"><i class="fas fa-clock"></i></div>'
              );
            }

            const codigo = datosFinales[i].codigo + "";

            var botonesCotizaciones = (
              <>
                <div style={{ width: "100%", textAlign: "center" }}>
                  <Link
                    to={
                      "/cotizacion-tercero/" +
                      this.state.idSimulacion +
                      "/" +
                      codigo
                    }
                  >
                    <i class="fas fa-info-circle"></i>
                  </Link>
                  &nbsp;&nbsp;
                </div>
              </>
            );
            //				alert( JSON.stringify( this.state.simulacion ) );

            var visualizarSeleccionar = false;
            if (
              this.state.simulacion.rfi != null &&
              this.state.simulacion.rfi == false
            ) {
              visualizarSeleccionar = true;
            }

            if (
              this.state.simulacion.estadoProceso == 5 &&
              datosFinales[i].estadoEnvio == 2 &&
              visualizarSeleccionar
            ) {
              botonesCotizaciones = (
                <>
                  <div style={{ width: "100%", textAlign: "center" }}>
                    <Link
                      to={
                        "/cotizacion-tercero/" +
                        this.state.idSimulacion +
                        "/" +
                        codigo
                      }
                    >
                      <i class="fas fa-info-circle"></i>
                    </Link>
                    &nbsp;&nbsp;
                  </div>
                </>
              );
            }

            var row = {
              consecutivo: consecutivo,
              proveedor: nombreProveedor,
              estadoEnvio: iconoEnvio,
              estadoCierre: iconoCierre,
              cantidad: scantidad,
              valor: stotal,
              botones: botonesCotizaciones,
            };

            rows.push(row);
          }
          if (
            this.state.simulacion.estadoProceso == 3 &&
            todasCotizacionesCerradas
          ) {
            mostrarBotonCerrarProcesoCotizacion = "initial";
          }

          var dataCotizacionesOtrosProveedores =
            dataCotizacionesOtrosProveedores;
          // if(this.state.tipoSimulador == 2){
          // columnasCotizaciones = this.state.dataCotizacionesOtrosProveedores;
          //}

          //  columnasCotizacionesOtrosProveedores: columnasCotizacionesOtrosProveedores, dataCotizacionesOtrosProveedores:{columns: columnasCotizacionesOtrosProveedores, rows:[]}
          var dataCotizacionesOtrosProveedores = {
            columns: columnasCotizacionesOtrosProveedores,
            rows: rows,
          };
          this.setState({
            dataCotizacionesOtrosProveedores: dataCotizacionesOtrosProveedores,
            mostrarBotonCerrarProcesoCotizacion:
              mostrarBotonCerrarProcesoCotizacion,
          });
        }.bind(this)
      )
      .catch(function (error) {});
  }

  handleAbrirNombreSubproducto(
    event,
    nombre,
    idItemCotizacion,
    idSubproductoActualizar,
    iva,
    valor
  ) {
    event.preventDefault();
    //event, nombreSubproducto, idItemCotizacionSubproducto, idSubproducto, 0, 0 ivaSubproducto, valorSubproducto
    this.setState(
      {
        mostrarModificarSubproducto: true,
        nombreSubproducto: nombre,
        idItemCotizacionActualizarSubproducto: idItemCotizacion,
        idSubproductoActualizarSubproducto: idSubproductoActualizar,
      },
      function () {
        // document.getElementById("ivaSubproductoModificar").value = iva;
        document.getElementById("valorSubproductoModificar").value = valor;
      }.bind(this)
    );
  }
  handleCloseNombreSubproducto() {
    this.setState({ mostrarModificarSubproducto: false });
  }
  actualizarSubproducto() {
    var codigo = localStorage.getItem("simuladores.proveedores.codigoUsuario");
    var valor = document.getElementById("valorSubproductoModificar").value;
    // var iva = document.getElementById("ivaSubproductoModificar").value;
    var idCotizacion = this.state.idCotizacion;
    var idItemCotizacion = this.state.idItemCotizacionActualizarSubproducto;
    var idSubproducto = this.state.idSubproductoActualizarSubproducto;

    this.setState({ respuestaSubproductos: "Actualizar subproducto" });

    var info = {
      codigo: codigo,
      valor: valor,
      idCotizacion: idCotizacion,
      idItemCotizacion: idItemCotizacion,
      idSubproducto: idSubproducto,
    };
    axios
      .post(
        misConstantes.URL_CONSULTA + "/ServletModificarValorIVASubproducto",
        info,
        { params: info }
      )
      .then(
        function (response) {
          this.setState({ respuestaSubproductos: response.data.mensaje });
          if (response.data.respuesta == "exito") {
            this.setState({
              mostrarModificarSubproducto: false,
              respuestaSubproductos: "",
            });
            this.cargarItemCotizacions();
            this.cargarCotizacion();
          }
        }.bind(this)
      )
      .catch(function (error) {});
  }
}

export default Cotizacion;
